export default {
  translation: {
    help: {
      title: "Help",
      center: "Help center",
      minimize: "Minimize",
      expand: "Enlarge",
      shrink: "Reduce size",
      askIntro:
        "Hi! Ask how something works. Answers are based on the help center and link to their sources.",
      askPlaceholder: "Type your question",
      send: "Send",
      thinking: "Thinking…",
      newConversation: "New",
      error: "The assistant could not answer. Try again.",
      rateLimited: "Too many questions right now. Try again in a moment.",
      openingHelp: "Opening the help center…",
      sessionFailed: "Could not open the help center. Try again.",
    },
    common: {
      loading: "Loading...",
      errorLoadingUser: "Error loading user",
      yes: "Yes",
      no: "No",
      retry: "Retry",
      initializing: "Initializing...",
      save: "Save",
      update: "Update",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      close: "Close",
      back: "Back",
      search: "Search",
      noMatches: "No matches",
      actions: "Actions",
      name: "Name",
      email: "Email",
      status: "Status",
      loadingEllipsis: "Loading...",
      listIdSubtitle: "ID: {{id}}",
      copiedToClipboard: "Copied to clipboard!",
      saveChanges: "Save changes",
      saving: "Saving...",
      updating: "Updating...",
      creating: "Creating...",
      type: "Type",
      amount: "Amount",
      remove: "Remove",
    },
    catalogOrigin: {
      STORE: "This store only",
      CHAIN: "Chain-wide",
    },
    catalogOriginShort: {
      STORE: "S",
      CHAIN: "C",
    },
    multiCurrencyMoneyInput: {
      addCurrency: "Add currency",
    },
    language: {
      swedish: "Svenska",
      english: "English",
      chooseLanguage: "Language",
    },
    app: {
      loadingStores: "Loading stores...",
      errorLoadingStores: "Error loading stores. Please try again.",
      noStoresAvailable: "No stores available",
    },
    login: {
      email: "Email",
      password: "Password",
      emailPlaceholder: "Enter your email",
      passwordPlaceholder: "Enter your password",
      signIn: "Sign In",
      signingIn: "Signing in...",
      logoAlt: "Kassaro",
      errors: {
        generic: "Failed to sign in",
      },
    },
    storeSelector: {
      title: "Select Store",
      subtitle: "Choose a store to continue",
    },
    navbar: {
      toggleMenu: "Toggle menu",
      staging: "Staging",
      storeSearchPlaceholder: "Search stores…",
      storeSearchSearching: "Searching…",
      storeSearchNoResults: "No stores found",
    },
    adminSidebar: {
      sectionTitle: "Admin Tools",
      dashboard: "Dashboard",
      stores: "Stores",
      availableBillingItems: "Available Billing Items",
      bundles: "Bundles",
      apiKeys: "API Keys",
      chains: "Chains",
      resellers: "Resellers",
      kickback: "Kickback",
    },
    resellerSidebar: {
      sectionTitle: "Reseller",
      overview: "Overview",
      stores: "Stores",
      users: "Users",
      invoicing: "Invoicing",
      availableBillingItems: "Available Billing Items",
      priceList: "Price list",
    },
    chainSidebar: {
      sectionTitle: "Chain",
      overview: "Overview",
      stores: "Stores",
      statistics: "Statistics",
      storeDebts: "Inter-store debt",
      catalog: "Catalog",
      settings: "Settings",
    },
    catalog: {
      products: "Products",
      productGroups: "Product groups",
      units: "Units",
      courses: "Courses",
      prepStations: "Prep stations",
      modifiers: "Modifiers",
      modifierGroups: "Modifier groups",
      bookkeepingAccounts: "Bookkeeping accounts",
      productPages: "Product pages",
      offers: "Offers",
      suppliers: "Suppliers",
      layouts: "Layouts",
      giftCards: "Giftcards",
      itemNotFound: "This item was not found.",
      unsavedTitle: "Unsaved changes",
      unsavedMessage: "You have unsaved changes. Discard them and leave?",
      discard: "Discard",
    },
    guards: {
      redirecting: "Redirecting...",
    },
    storeDropdown: {
      selectStore: "Select store",
    },
    userDropdown: {
      signOut: "Sign out",
    },
    firebaseConsole: {
      openDocument: "Firestore",
    },
    gcpLogs: {
      openQuery: "Logs",
    },
    overview: {
      loadingStore: "Loading store...",
      loadingStoreInfo: "Loading store information...",
      storeNotFound: "Store not found",
      storeName: "Store Name",
      displayName: "Display Name",
      organizationNumber: "Organization Number",
      address: "Address",
      contactPerson: "Contact person",
      contactEmail: "Contact email",
      contactPhone: "Contact phone",
      country: "Country",
      currency: "Currency",
      language: "Language",
      timeZone: "Time Zone",
      chain: "Chain",
      reseller: "Reseller",
      noReseller: "No Reseller",
      createdAt: "Created At",
      dailySalesLast30Days: "Daily Sales (Last 30 Days)",
      saveStore: "Save",
      savingStore: "Saving…",
      orgNumberReadOnlyHint:
        "The organization number cannot be changed while this store has an active cash register.",
      updateStoreFailed: "Could not save changes.",
      storeSaved: "Store details saved.",
    },
    billingItems: {
      addButton: "Add Packages, Addons & Hardware",
      switchPackage: "Switch package",
      switchPackageConfirm: "Switch package",
      manageAddons: "Manage add-ons",
      addOtherItems: "Add terminals & hardware",
      noAddonsAvailable: "No add-ons are available for this store.",
      noOtherItemsAvailable:
        "No payment terminals or hardware are available for this store.",
      itemNames: {},
      sectionTitle: "Current billing items",
      loading: "Loading...",
      empty: "No billing items yet.",
      table: {
        name: "Name",
        type: "Type",
        invoicePeriod: "Invoice period",
        timeline: "Quantity over time",
        startDate: "Start date",
        endDate: "End date",
        paidUntil: "Paid until",
        status: "Status",
      },
      timeline: {
        segment: "{{quantity}} from {{from}} until {{until}}",
        ongoing: "further notice",
        untilFurtherNotice: "until further notice",
      },
      status: {
        upcoming: "Upcoming",
        active: "Active",
        ended: "Ended",
        ordered: "Ordered",
      },
      type: {
        PACKAGE: "Package",
        ADD_ON: "Add-on",
        HARDWARE: "Hardware",
        PAYMENT_METHOD: "Payment terminal",
        EXTRA_DEVICE: "Extra device",
      },
      billingPeriod: {
        MONTHLY: "Monthly",
        QUARTERLY: "Quarterly",
        YEARLY: "Yearly",
        TWO_YEARS: "2 years",
        THREE_YEARS: "3 years",
        FOUR_YEARS: "4 years",
        FIVE_YEARS: "5 years",
      },
      hardware: {
        category: {
          handheld: "Handheld",
          tablet: "Tablet",
          desktop: "Desktop",
          other: "Other",
        },
      },
      actions: {
        activate: "Activate now",
        activating: "Activating...",
        cancel: "End",
        cancelling: "Ending...",
        cancelConfirm:
          "Are you sure you want to end this billing item?",
      },
      edit: {
        isDemo: "Demo",
        paidUntil: "Paid until",
        discountAmount: "Discount amount",
        startDateLocked:
          "Start date and invoice period cannot be changed once billing has started.",
        segments: "Quantity periods",
        addSegment: "Add period",
        removeSegment: "Remove period",
        duplicateSegmentDates: "Each period must have a unique start date.",
        endDateInPast: "End date cannot be in the past.",
        endDateBeforeMinimum:
          "The end date must be at least one month after the start date ({{minimumDate}}). It will be adjusted automatically when saved.",
        effectiveFromBeforeMinimum:
          "Changes cannot take effect before {{minimumDate}}. The date will be adjusted automatically when saved.",
        cancelBeforeMinimum:
          "This billing item must remain active until at least {{minimumDate}}. Ending it now will take effect from that date.",
        endDatePaidUntilLimit:
          "This item is paid until {{paidUntilDate}}. The end date cannot be set before then.",
        endDateBeforePaidUntil:
          "End date cannot be before the paid until date ({{paidUntilDate}}).",
      },
    },
    kickback: {
      title: "Kickback",
      description:
        "Calculate the resellers' share of Viva ISV fees and Paytrim and Elavon compensation and deduct it as negative rows at the top of the reseller's invoice. Pick the same period as the invoice under Invoicing: the invoice generated at the start of October has the period October and gets Viva for September and Paytrim and Elavon for August, since they report a month later. The reseller's share is the amount excluding VAT (× 0.8) split in half.",
      loadError: "Could not load kickback.",
      loading: "Loading kickback...",
      period: "Invoice period",
      dataPeriod: "Covers",
      source: {
        VIVA: "Viva ISV fee",
        PAYTRIM: "Paytrim",
        ELAVON: "Elavon",
      },
      sourceHint: {
        VIVA: "Fetched from Viva for the whole month. Merchant IDs are matched to the chains' Viva integrations.",
        PAYTRIM: "Excel file with the columns Name and Compensation for the month under Covers. Company names are matched to stores.",
        ELAVON: "Excel file with the columns Name and Compensation for the month under Covers. Company names are matched to stores.",
      },
      notLoaded: "Not loaded for the period.",
      updatedAt: "Updated",
      file: "File",
      grossAmount: "Amount incl. VAT",
      profitShare: "Reseller share",
      unmatched: "Without reseller",
      skippedRows: "Rows without a valid amount",
      fetchViva: "Fetch from Viva",
      refetchViva: "Fetch again",
      fetching: "Fetching...",
      uploadReport: "Upload report",
      uploading: "Uploading...",
      unmatchedTitle: "Rows without reseller",
      unmatchedDescription:
        "These rows are not included on any invoice. Pick a store for Paytrim and Elavon companies; the choice is saved and reused next period. If a store is already matched, it has no reseller.",
      sourceColumn: "Source",
      reference: "Company / merchant ID",
      matchedTo: "Matched to",
      match: "Pick store",
      noMatch: "No match",
      noReseller: "no reseller",
      vivaUnmatchedHint: "Add the Viva integration to the right chain and fetch again.",
      perResellerTitle: "Per reseller",
      perResellerDescription:
        "These amounts are deducted at the top of the reseller's invoice for the same period when the invoice is generated under Invoicing. If the invoice is already generated but not sent, generate it again to include changes.",
      noResellerTotals: "No kickback for the period yet.",
      reseller: "Reseller",
      rows: "Rows",
    },
    invoice: {
      kickbackRow: "Kickback – {{source}}",
      kickbackMissing:
        "No kickback report existed for {{sources}} when the invoice was generated. Upload or fetch it under Kickback and generate the invoice again if it should be included.",
      kickbackType: "Kickback",
      sectionTitle: "Invoicing",
      loading: "Loading invoices...",
      emptyList: "No invoices yet.",
      generateButton: "Generate Invoice",
      generating: "Generating...",
      markAsSent: "Create draft in Bokio",
      markingAsSent: "Creating draft...",
      panelTitle: "Invoice Preview",
      period: "Period",
      generatedAt: "Generated",
      total: "Total",
      sent: "In Bokio",
      empty: "No line items in this invoice.",
      lineItem: {
        name: "Name",
        type: "Type",
        store: "Store",
        period: "Period",
        months: "Months",
        unitPrice: "Unit price",
        total: "Total",
      },
    },
    availableBillingItemsView: {
      title: "Available Billing Items",
      loading: "Loading available billing items...",
      createButton: "Create Available Billing Item",
      errorLoading: "Error loading available billing items. Please try again.",
      errorUpdating: "Error updating available billing item. Please try again.",
      successCreated: "Available billing item created successfully",
      successUpdated: "Available billing item updated successfully",
      successArchived: "Available billing item archived",
      empty: "No available billing items yet. Create one to get started.",
      table: {
        name: "Name",
        type: "Type",
        pricing: "Pricing",
        actions: "Actions",
      },
      archive: "Archive",
      archived: "Archived",
      archiveConfirm:
        "Archive this billing item? It will be removed from reseller catalogs and can no longer be added to stores. Existing subscriptions stay active.",
      panelCreateTitle: "Create Available Billing Item",
      panelEditTitle: "Edit Available Billing Item: {{name}}",
      pricing: {
        monthly: "Monthly",
        oneTime: "One-time",
        prepaid36: "36mo",
      },
    },
    availableBillingItemForm: {
      type: "Type",
      selectType: "Select a type",
      name: "Name",
      description: "Description",
      comingSoon: "Coming Soon",
      comingSoonLabel: "Mark as coming soon",
      bulletsOptional: "Bullets (Optional)",
      bulletPoint: "Bullet point {{index}}",
      addBullet: "Add Bullet",
      remove: "Remove",
      categoryOptional: "Category (Optional)",
      selectCategory: "Select a category",
      features: "Features",
      feature: {
        FISCALIZATION: "Cash register",
        DISCOUNT: "Discount",
        GROUPS: "Product groups",
        PRODUCT_VARIANTS: "Product variants",
        RESTAURANT_VARIANTS: "Restaurant variants",
        LAYOUTS: "Layouts",
        FLOOR_PLANS: "Floor plans",
        CREDIT_NOTE: "Credit note",
        GIFT_CARD: "Gift card",
        AUTOMATIC_BOOKKEEPING: "Automatic bookkeeping",
        RECEIPT_LOGO: "Receipt logo",
        EXTRA_PRODUCT_FIELDS: "Extra product fields",
        CUSTOMER_DISPLAY: "Customer display",
        BARCODE_SCANNING: "Barcode scanning",
        SIMPLE_STOCK: "Stock levels",
        PHONE_SUPPORT: "Phone support",
        BUNDLE_MANAGEMENT: "Version management",
        LABEL_PRINTING: "Label printing",
        ORDER: "Order",
        INVOICE: "Invoice",
        PURCHASE_NOTE: "Purchase note",
        SERIAL_SCALE: "Serial scale",
        PRODUCT_INFO_BOX: "Product information",
        MODIFIERS: "Modifiers",
        TIPS: "Tips",
        PREP_TICKETS: "Prep tickets",
        COMBINED_PREP_TICKETS: "Combined prep ticket",
        SAVE_TABS: "Save tabs",
        SPLIT_TABS: "Split tabs",
        BILL_PREVIEW: "Proforma",
        TAKEOUT_PRICE: "Takeout price",
        ONLINE_ORDER: "Online order",
        PURCHASE_PRICE: "Purchase price",
        STAFF: "Staff",
        INTAKE: "Intake",
        PRODUCT_SYNC: "Product sync",
        PRODUCT_IMAGES: "Product images",
        STOCK_TAKE: "Stock take",
        STOCK_LOCATIONS: "Stock locations",
        STOCK_POLICIES: "Stock policies",
        INVENTORY_COSTING: "FIFO costing and serial numbers",
        SUPPLIERS: "Suppliers",
        OFFERS: "Offers",
        CUSTOMERS: "Customers",
        SERVICE_ORDERS: "Service orders",
        EXTERNAL_INTEGRATIONS: "External integrations",
        PUBLIC_API: "Public API and webhooks",
      },
      grants: "Included capacity",
      grantsAdditionalDevices: "Additional devices per unit",
      grantsPaymentTerminals: "Payment terminals included per unit (optional)",
      grantsPaymentTerminalCount: "Count",
      addPaymentTerminal: "Add payment terminal",
      grantsNotIncluded: "Not included",
      paymentProvider: {
        SOFTPAY: "Softpay",
        WESTPAY: "Westpay",
        MARKETPAY: "Marketpay",
        VIVA: "Viva",
        NETS: "Nets",
      },
      image: "Image",
      selectedImage: "Selected: {{name}} ({{size}} KB)",
      imagePreviewAlt: "Image preview",
      monthlyPriceOptional: "Monthly Price (Optional)",
      oneTimePriceOptional: "One-Time Price (Optional)",
      prepaid36MonthPriceOptional: "Prepaid 36 Month Price (Optional)",
      amountPlaceholder: "Amount (kr)",
      cancel: "Cancel",
      create: "Create",
      update: "Update",
    },
    statistics: {
      title: "Statistics",
      loading: "Loading statistics...",
      retry: "Retry",
      days: "Days",
      weeks: "Weeks",
      months: "Months",
      weekLabel: "Week {{number}}",
      weekLabelWithYear: "Week {{number}} {{year}}",
      totalSalesAmount: "Total Sales Amount",
      overviewTotalSales: "Total Sales",
      overviewTotalRefunds: "Total Refunds",
      overviewTotalDiscounts: "Total Discounts",
      overviewReceiptCount: "Receipt Count",
      mostSoldProducts: "Most Sold Products",
      mostSoldGroups: "Most Sold Groups",
      quantityUnit: "pcs",
      productsColumnName: "Product",
      productsColumnCost: "Cost of goods",
      productsColumnMargin: "Margin",
      productsCostProvisional:
        "* Provisional cost: more was sold than was in stock, or the cost is not calculated yet.",
      groupsColumnName: "Group",
      receiptTypes: "Receipt Types",
      receiptTypesColumnType: "Type",
      receiptTypesColumnCount: "Count",
      receiptTypesColumnAmount: "Amount",
      salesByPaymentMethod: "Sales by Payment Method",
      hourOfDay: "Sales by Hour",
      orderByQuantity: "By Quantity",
      orderByAmount: "By Amount",
      noProductsSold: "No products sold",
      noGroupsSold: "No groups sold",
      couldNotLoadReport: "Could not load report",
      back: "Back",
      previousPeriod: "Previous period",
      nextPeriod: "Next period",
      selectPeriod: "Select period",
      startDate: "Start date",
      endDate: "End date",
      apply: "Apply",
      refresh: "Refresh",
      refreshing: "Refreshing...",
      lastUpdated: "Last updated {{time}}",
      updatedMinutesAgo: "Updated {{minutes}} min ago",
      refreshDisabledCooldown: "Statistics can be updated at most every 30 minutes. Try again in {{minutes}} min.",
      storesIncluded: "{{included}} of {{total}} stores",
      stores: "Stores",
      storeColumnName: "Store",
      storeShare: "Share",
      clearStoreFilter: "Show all stores",
      showingStore: "Showing {{name}}",
      receiptType: {
        RECEIPT: "Receipt",
        REFUND: "Refund",
        PAYOUT: "Purchase note",
        INVOICE: "Invoice",
        ORDER: "Order",
      },
    },
    resellerTopList: {
      sectionTitle: "Reseller leaderboard",
      reseller: "Reseller",
      activeCustomers: "Active customers",
      activeLicenses: "Active licenses",
      customerGrowth: "Customer growth",
      customerBreakdown: "{{added}} new, {{removed}} lost",
      licenseBreakdown: "{{added}} new, {{removed}} removed",
      licenseGrowth: "License growth",
      datesSubtitle: "Compared to {{baselineDate}}, as of {{asOfDate}}",
      empty: "No ranking data for this month",
      anonymousRank: "#{{rank}}",
      you: "You",
    },
    licenseChanges: {
      sectionTitle: "License changes",
      store: "Store",
      reseller: "Reseller",
      license: "License",
      change: "Change",
      date: "Date",
      status: "Status",
      statusNew: "New",
      statusTerminated: "Terminated",
      statusChanged: "Changed",
      statusQuantityChanged: "Quantity changed",
      filterAll: "All changes",
      filterAdded: "New licenses (+{{count}})",
      filterRemoved: "Removed licenses (−{{count}})",
      empty: "No license changes this month",
    },
    adminMrrStats: {
      sectionTitle: "MRR and ARR",
      mrrToday: "MRR today ({{currency}})",
      mrrOnDate: "MRR ({{currency}}, {{date}})",
      arrToday: "ARR today ({{currency}})",
      arrOnDate: "ARR ({{currency}}, {{date}})",
      payingStoresToday: "Paying stores today",
      payingStoresOnDate: "Paying stores ({{date}})",
      comparedTo: "compared with {{date}}",
      noComparison: "No data for {{date}}",
      mrrPerDay: "MRR per day ({{currency}})",
      currentPeriod: "Selected period",
      previousPeriod: "Previous period",
    },
    adminLicenseStats: {
      sectionTitle: "Licenses",
      activeLicensesPerDay: "Active Licenses per Day",
      recalculateToday: "Recalculate today",
      computing: "Computing...",
      uniqueStores: "Unique stores",
      uniqueStoresToday: "Unique stores today",
      uniqueStoresOnDate: "Unique stores ({{date}})",
      totalLicensesToday: "Total licenses today",
      totalLicensesOnDate: "Total licenses ({{date}})",
      packagesToday: "Packages today",
      packagesOnDate: "Packages ({{date}})",
      addOnsToday: "Add-ons today",
      addOnsOnDate: "Add-ons ({{date}})",
      licenseTypesToday: "License Types (today)",
      licenseTypesOnDate: "License Types ({{date}})",
      noDataToday: "No data for today yet",
      noDataOnDate: "No data for {{date}} yet",
    },
    adminDailySales: {
      sectionTitle: "Sales",
      dailySalesChart: "Daily Sales",
      maxPeriodDays: "Maximum {{days}} days per period",
      period: {
        thisMonth: "This month",
        lastMonth: "Last month",
        last30Days: "Last 30 days",
        custom: "Custom",
      },
      receiptsToday: "Receipts today",
      receiptsOnDate: "Receipts ({{date}})",
      grossSalesToday: "Gross sales today ({{currency}})",
      grossSalesTodayGeneric: "Gross sales today",
      grossSalesOnDate: "Gross sales ({{currency}}, {{date}})",
      grossSalesOnDateGeneric: "Gross sales ({{date}})",
      grossSales: "Gross sales",
      periodTotalSales: "Total sales ({{period}})",
      receiptCount: "Receipt count",
      paymentMethods: "Payment Methods",
      paymentMethodsToday: "Payment Methods (today)",
      paymentMethodsOnDate: "Payment Methods ({{date}})",
      other: "Other",
      salesByCurrencyToday: "Sales by Currency (today)",
      salesByCurrencyOnDate: "Sales by Currency ({{date}})",
      salesByReceiptTypeToday: "Sales by Receipt Type (today)",
      salesByReceiptTypeOnDate: "Sales by Receipt Type ({{date}})",
      noDataToday: "No data for today yet",
      noDataOnDate: "No data for {{date}} yet",
    },
    paymentProvider: {
      SOFTPAY: "Softpay",
      WESTPAY: "Westpay",
      MARKETPAY: "Market Pay",
      VIVA: "Viva",
      NETS: "Nets",
    },
    paymentCategory: {
      CARD: "Card",
      SWISH: "Swish",
    },
    paymentMethodType: {
      CASH: "Cash",
      SWISH_COMPANY: "Swish Company",
      SWISH_COMMERCE: "Swish Commerce",
      NETS_MOCK: "Nets Mock",
      NETS_TERMINAL: "Nets Terminal",
      WESTPAY_CLOUD: "Westpay Cloud",
      VIVA: "Viva",
      VIVA_CLOUD: "Viva Cloud",
      VIVA_SMART_CHECKOUT: "Viva Smart Checkout",
      SOFTPAY: "Softpay",
      CREDIT_NOTE: "Credit Note",
      GIFT_CARD: "Gift Card",
      OTHER: "Other",
      INVOICE: "Invoice",
      ORDER: "Order",
      MARKETPAY_CLOUD: "Marketpay Cloud",
      MARKETPAY_LOCAL: "Marketpay Local",
    },
    import: {
      dropZoneHint: "Drop CSV file here",
      csvFileLabel: "CSV file *",
      selectedFileKb: "Selected: {{name}} ({{size}} KB)",
      dropFileHint: "You can also drag and drop a CSV anywhere on this page.",
      sectionAdvancedOptionsSummary: "More options (optional)",
      optionsSkipFirstRow: "Skip first row",
      optionsSkipFirstRowToggle: "Skip first row",
      optionsEncoding: "Character encoding",
      optionsDelimiter: "Delimiter",
      encodingUtf8: "UTF-8",
      encodingLatin1: "Latin-1",
      delimiterComma: "Comma (,)",
      delimiterSemicolon: "Semicolon (;)",
    },
    productImport: {
      title: "Import Products",
      pageDescription:
        "Upload a CSV, map columns, then run a test import. Rows merge with existing products by Kassaro ID, then article number, then barcode. Large imports may continue in the background.",
      sectionUploadTitle: "1. File and CSV format",
      sectionUploadDescription:
        "Pick your CSV file. Encoding (UTF-8 vs Latin-1) and the column delimiter are detected automatically. Open More options if you need to override them or change other import behavior.",
      sectionMatchExplanation:
        "Each row is matched to an existing product using the fields you enable in More options. By default that is Kassaro product ID, then article number, then barcode. When a match is found, that product is updated; otherwise a new product is created.",
      sectionAdvancedOptionsIntro:
        "Override encoding or delimiter if the automatic detection is wrong—with a file already selected, the preview updates as soon as you change them. You can also choose whether the first row is a header, whether new products may be created, and which fields identify an existing product or variant.",
      sectionMappingTitle: "2. Map columns",
      sectionMappingDescription:
        "Match each column from your file to a product field, or choose Skip. Custom fields from your store appear at the end of each list.",
      mapAtLeastOneHint: "Map at least one column to a product field to unlock the test import step.",
      mappingTableSourceColumn: "Column in file",
      mappingTableTargetField: "Product field",
      extraFieldLabel: "Extra field: {{name}}",
      sectionActionsTitle: "3. Test, then import",
      sectionActionsDescription:
        "Run a dry run first: nothing is saved, but you see a preview and any row errors. When the test succeeds, use Import products to apply changes.",
      runDryRun: "Run Dry Run",
      running: "Running...",
      parseCsvFailed: "Failed to parse CSV: {{message}}",
      selectCsvFile: "Please select a CSV file",
      noCsvHeaders: "No CSV headers detected",
      dryRunFailed: "Dry run failed",
      failedRunDryRun: "Failed to run dry run",
      runDryRunFirst: "Please run a dry run first",
      importFailed: "Failed to import products",
      importStartedTracking: "Import started! Tracking progress...",
      dryRunCompletedReview: "Dry run completed successfully. Review the results below.",
      productsImportedSuccess: "Products imported successfully!",
      columnField: {
        SKIP: "Skip",
        ID: "Kassaro ID",
        NAME: "Name",
        ARTICLE_NUMBER: "Article number",
        BARCODE: "Barcode",
        MANUFACTURER_ARTICLE_NUMBER: "Manufacturer article number",
        MANUFACTURER_BARCODE: "Manufacturer barcode",
        INFORMATION: "Information",
        UNIT_PRICE: "Unit price (retail)",
        VAT: "VAT",
        GROUP_ID: "Group ID",
        GROUP_NAME: "Group name",
        SUPPLIER: "Supplier",
        SUPPLIER_ID: "Supplier ID",
        UNIT: "Unit",
        UNIT_ID: "Unit ID",
        PRODUCT_SYNC_ENABLED: "Product sync enabled",
        BOOKKEEPING_ACCOUNT_ID: "Bookkeeping account ID",
        BOOKKEEPING_ACCOUNT_NUMBER: "Bookkeeping account number",
        STOCK_COUNT: "Stock count",
        STOCK_POLICY: "Stock policy (name)",
        STOCK_MIN: "Minimum stock",
        STOCK_MAX: "Fill stock up to",
        PURCHASE_PRICE: "Purchase price",
        TAKEAWAY_VAT: "Takeaway tax (VAT)",
        TAKEAWAY_PRICE: "Takeaway price",
        TAKEAWAY_BOOKKEEPING_ACCOUNT_ID: "Takeaway bookkeeping account ID",
        TAKEAWAY_BOOKKEEPING_ACCOUNT_NUMBER: "Takeaway bookkeeping account number",
        VARIANT_ID: "Variant ID",
      },
      variantsSectionTitle: "Variant import",
      variantsVariantIdOptionalHint:
        "Variant ID is optional. When omitted, IDs are generated automatically for each variant row.",
      variantsHelpRestaurant:
        "Choose a group column below. Rows with the same value become one product. The first row is the parent; following rows become variants.",
      variantsHelpRetail:
        "Choose a group column below. Rows with the same value become one product. Every row in the group becomes a variant, including the first.",
      variantGroupColumnLabel: "Group variants by",
      variantGroupColumnPlaceholder: "None",
      variantGroupColumnOption: "{{sourceColumn}} → {{targetField}}",
      variantGroupColumnHelp:
        "Optional. Rows with the same value in this field are grouped into one product.",
      variantGroupColumnRequired:
        "Select a column to group variants by.",
      firstRowAsVariantLabel: "First row is also a variant",
      firstRowAsVariantToggle: "Include the first row in each group as a variant",
      firstRowAsVariantHelpRestaurant:
        "The first row defines the parent product only. Use this for restaurant-style menus where variants are add-ons or sizes on top of a base product.",
      firstRowAsVariantHelpRetail:
        "The first row defines the parent product and counts as a variant. Use this for retail where every size or option is its own variant row.",
      delimiterTab: "Tab",
      delimiterPipe: "Pipe (|)",
      optionsOnlyUpdate: "Only update existing products (do not create new)",
      optionsOnlyUpdateToggle: "Only update existing products (do not create new)",
      optionsAddStock: "Add to existing stock",
      optionsAddStockToggle: "Add imported stock to current stock instead of replacing it",
      optionsAddStockHelp:
        "When a product already exists, imported stock is added to the current quantity. New products still get the imported stock as their starting quantity, unless only-update is on.",
      matchFieldsLabel: "Match existing products by",
      matchFieldsHelp:
        "Used in this order when looking up a product or variant already in the store. Turn off a field to skip it. Extra fields and variant ID apply when importing variants.",
      matchFieldId: "Kassaro ID",
      matchFieldArticleNumber: "Article number",
      matchFieldBarcode: "Barcode",
      matchFieldVariantId: "Variant ID",
      matchFieldExtraFields: "Extra fields (all must match)",
      dryRunResultsTitle: "Dry Run Results",
      dryRunResultsDescription:
        "Review counts and sample rows below. Fix any errors in your file or mapping, then run the dry run again before importing.",
      dryRunSuccessNoErrors:
        "Dry run completed successfully with no errors. You can now proceed with the import.",
      importProducts: "Import Products",
      importing: "Importing...",
      metaTotalRows: "Total products",
      metaValidRows: "Valid products",
      metaErrors: "Errors",
      metaStatus: "Status",
      metaSuccess: "Success",
      metaFailed: "Failed",
      errorsFoundOne: "Found 1 error. Please fix the errors before importing.",
      errorsFoundMany: "Found {{count}} errors. Please fix the errors before importing.",
      errorsTitle: "Errors ({{count}})",
      tableRow: "Row",
      tableField: "Field",
      tableMessage: "Message",
      tableValue: "Value",
      validProductsPreview: "Valid products preview",
      validName: "Name",
      validGroup: "Group",
      validArticleNumber: "Article number",
      validBarcode: "Barcode",
      validUnitPrice: "Unit price",
      validPurchasePrice: "Purchase price",
      validVat: "VAT",
      validStock: "Stock",
      validBookkeepingAccount: "Bookkeeping account",
      validVariants: "Variants",
      validVariantRow: "↳ {{name}}",
      validVariantStock: "stock {{count}}",
      validTakeawayTax: "Takeaway VAT",
      validTakeawayPrice: "Takeaway price",
      validTakeawayBookkeepingAccount: "Takeaway bookkeeping account",
      validExtraProductFields: "Extra product fields",
      progressTitle: "Import progress",
      progressDescription:
        "Large imports keep running on the server. You can navigate away; progress updates when you return.",
      progressLoadingDescription: "Loading the current import job…",
      statusPending: "Pending",
      statusProcessing: "Processing",
      statusCompleted: "Completed",
      statusFailed: "Failed",
      productsProcessed: "{{processed}} / {{total}} products processed",
      succeeded: "{{count}} succeeded",
      failedRows: "{{count}} failed",
      jobQueued: "Import job is queued and will start processing shortly...",
      importCompletedSuccess: "Import completed successfully!",
      productsImportedCount: "{{count}} products imported",
      importFailedShort: "Import failed.",
      jobHistoryTitle: "Recent import jobs",
      jobHistoryDescription: "The latest background import jobs for this store.",
      jobHistoryStatus: "Status",
      jobHistoryProgress: "Progress",
      jobHistoryStarted: "Started",
      jobHistoryCompleted: "Completed",
      jobSucceeded: "{{count}} succeeded",
      skippedChainRows: "{{count}} skipped (managed by the chain catalog)",
      chainImportInfo:
        "Products are imported into the chain catalog. New product groups, suppliers and bookkeeping accounts are created in the chain, and everything is synced to all stores.",
      storeImportScopedInfo:
        "Products are imported to this store only. Rows matching products from the chain catalog are skipped, and new groups, suppliers or bookkeeping accounts can only be created if the chain allows local items.",
      storeImportLocked:
        "Product import is managed by the chain for this store. Import products from the chain catalog instead.",
    },
    giftcardImport: {
      title: "Import gift cards",
      sectionUploadTitle: "1. File and CSV format",
      sectionUploadDescription:
        "Pick your CSV file. Encoding (UTF-8 vs Latin-1) and the column delimiter are detected automatically. Open More options if you need to override them or change other import behavior.",
      sectionMatchExplanation:
        "Each row is matched to an existing gift card by Kassaro ID, then by card number. When a match is found, that gift card is updated; otherwise a new gift card is created (unless only-update mode is on).",
      sectionAdvancedOptionsIntro:
        "Override encoding or delimiter if the automatic detection is wrong—with a file already selected, the preview updates as soon as you change them. You can also choose whether the first row is a header and whether only existing gift cards may be updated.",
      sectionMappingTitle: "2. Map columns",
      sectionMappingDescription:
        "Match each column from your file to a gift card field, or choose Skip.",
      mapAtLeastOneHint: "Map at least one column to a gift card field to unlock the test import step.",
      mappingTableSourceColumn: "Column in file",
      mappingTableTargetField: "Gift card field",
      sectionActionsTitle: "3. Test, then import",
      sectionActionsDescription:
        "Run a dry run first: nothing is saved, but you see a preview and any row errors. When the test succeeds, use Import gift cards to apply changes.",
      runDryRun: "Run dry run",
      running: "Running...",
      parseCsvFailed: "Failed to parse CSV: {{message}}",
      selectCsvFile: "Please select a CSV file",
      noCsvHeaders: "No CSV headers detected",
      dryRunFailed: "Dry run failed",
      failedRunDryRun: "Failed to run dry run",
      runDryRunFirst: "Please run a dry run first",
      importFailed: "Failed to import gift cards",
      dryRunCompletedReview: "Dry run completed successfully. Review the results below.",
      columnField: {
        SKIP: "Skip",
        ID: "Kassaro gift card ID",
        CARD_NUMBER: "Card number",
        INITIAL_AMOUNT: "Initial amount",
        REMAINING_AMOUNT: "Remaining amount",
        VALID_UNTIL: "Valid until",
        STATUS: "Status",
      },
      optionsOnlyUpdate: "Only update existing gift cards (do not create new)",
      optionsOnlyUpdateToggle: "Only update existing gift cards (do not create new)",
      dryRunResultsTitle: "Dry run results",
      dryRunResultsDescription:
        "Review counts and sample rows below. Fix any errors in your file or mapping, then run the dry run again before importing.",
      dryRunSuccessNoErrors:
        "Dry run completed successfully with no errors. You can now proceed with the import.",
      importGiftcards: "Import gift cards",
      importing: "Importing...",
      metaTotalRows: "Total rows",
      metaValidRows: "Valid rows",
      metaErrors: "Errors",
      metaStatus: "Status",
      metaSuccess: "Success",
      metaFailed: "Failed",
      errorsFoundOne: "Found 1 error. Please fix the errors before importing.",
      errorsFoundMany: "Found {{count}} errors. Please fix the errors before importing.",
      errorsTitle: "Errors ({{count}})",
      tableRow: "Row",
      tableField: "Field",
      tableMessage: "Message",
      tableValue: "Value",
      validGiftcardsPreview: "Valid gift cards preview",
      validCardNumber: "Card number",
      validInitialAmount: "Initial amount",
      validRemainingAmount: "Remaining amount",
      validValidUntil: "Valid until",
      validStatus: "Status",
      importSuccessSummary:
        "Import finished. Created: {{created}}, updated: {{updated}}, skipped: {{skipped}}, failed: {{failed}}.",
    },
    devicesView: {
      title: "Devices",
      loading: "Loading devices...",
      errorLoad: "Error loading devices. Please try again.",
      errorUpdate: "Error updating device. Please try again.",
      successUpdated: "Device updated successfully",
      tableName: "Name",
      tableSerialNumber: "Serial number",
      tablePlatform: "Platform",
      tableDeviceModel: "Model",
      tableOsVersion: "OS version",
      tableAppVersion: "App version",
      tableActive: "Active",
      tableDeviceConfig: "Device config",
      tableLastSeen: "Last seen",
      tableCreated: "Created",
      unnamedDevice: "Unnamed device",
      none: "None",
      empty:
        "No devices registered yet. Devices will appear here when they first connect to this store.",
      editTitle: "Edit device: {{name}}",
      tableLicensed: "License",
      tableActions: "Actions",
      licensedYes: "Within limit",
      licensedNo: "Over limit",
      pendingClassification: "Needs classification",
      classifyAction: "Classify",
      activateAction: "Activate",
      deactivateAction: "Deactivate",
      classifyTitle: "Classify device: {{name}}",
      classifyNewDevice: "New device",
      classifyNewDeviceHint:
        "Raises the licensed device count from the day the device appeared.",
      classifyReplacement: "Replacement",
      classifyReplacementHint:
        "Retires the replaced device. The licensed device count stays the same.",
      replacementSuggestion:
        "{{name}} stopped being seen around the same time ({{lastSeen}}), which looks like a reinstall.",
      replacedDevice: "Replaced device",
      selectReplacedDevice: "Select device",
      classifyConfirm: "Classify",
      licensedSummary: "{{active}} active / {{limit}} licensed",
      pendingClassificationCount_one: "{{count}} needs classification",
      pendingClassificationCount_other: "{{count}} need classification",
    },
    printersView: {
      title: "Printers",
      loading: "Loading printers...",
      createPrinter: "Create printer",
      errorLoad: "Error loading printers. Please try again.",
      errorCreate: "Error creating printer. Please try again.",
      errorUpdate: "Error updating printer. Please try again.",
      errorDelete: "Error deleting printer. Please try again.",
      successCreated: "Printer created successfully",
      successUpdated: "Printer updated successfully",
      successDeleted: "Printer deleted successfully",
      deleteConfirm: "Are you sure you want to delete this printer?",
      empty: "No printers yet. Create one to get started.",
    },
    usersView: {
      title: "Users",
      loading: "Loading users...",
      addUser: "Add user",
      errorLoad: "Error loading users. Please try again.",
      errorRemove: "Error removing user access. Please try again.",
      successAdded: "User added successfully",
      successRemoved: "User access removed successfully",
      successPermissionGroupUpdated: "Permission group updated successfully",
      removeConfirm: "Are you sure you want to remove access for {{email}}?",
      tableEmail: "Email",
      tableName: "Name",
      tableRole: "Role",
      tableAccess: "Access",
      accessChain: "Chain",
      accessStore: "Store",
      tablePermissionGroup: "Permission group",
      tableCreated: "Created",
      tableActions: "Actions",
      remove: "Remove",
      empty: "No users found.",
      panelAddTitle: "Add user",
      thisUser: "this user",
      selectPermissionGroup: "Select permission group",
      errorPermissionGroupUpdate: "Error updating permission group. Please try again.",
      changePassword: "Change password",
      panelChangePasswordTitle: "Change password",
      successPasswordChanged: "Password changed successfully",
    },
    changePasswordForm: {
      description:
        "Enter a new password for {{email}}. The user is signed out on all devices and must sign in again with the new password.",
      passwordLabel: "New password *",
      passwordPlaceholder: "Enter new password",
      passwordRequired: "Password is required",
      passwordMinLength: "Password must be at least 6 characters",
      confirmLabel: "Confirm password *",
      confirmPlaceholder: "Enter the password again",
      confirmMismatch: "Passwords do not match",
      errorChange: "Could not change password. Please try again.",
      saving: "Saving...",
      save: "Change password",
    },
    paymentMethodsView: {
      create: "New payment method",
      selectType: "Select payment method type",
      title: "Payment methods",
      loading: "Loading payment methods...",
      errorLoad: "Could not load payment methods.",
      empty: "No payment methods found.",
      tableName: "Name",
      tableType: "Type",
    },
    paymentMethodForm: {
      newPaymentMethod: "New payment method",
      createdSuccessfully: "Payment method created",
      invalidType: "Unknown payment method type.",
      editPaymentMethod: "Edit payment method",
      loading: "Loading payment method...",
      errorLoad: "Could not load payment method.",
      updatedSuccessfully: "Payment method updated",
      deletePaymentMethod: "Delete payment method",
      deleteConfirmationMessage:
        'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
      basicInformation: "Basic information",
      additionalSettings: "Additional settings",
      name: "Name",
      type: "Type",
      bookkeepingAccount: "Bookkeeping account",
      defaultAccount: "Default",
      color: "Color",
      clearColor: "Remove color",
      openCashDrawer: "Open cash drawer after sale",
      useChangeCalculator: "Use change calculator",
      askForAmount: "Ask for amount when paying",
      integration: "Integration",
      integrationRequired: "Integration required",
      selectIntegration: "Select integration",
      noIntegration: "None – document only",
      emailDocumentToStore: "Send document to the store report email",
      terminalId: "Terminal ID",
      noneSelected: "None selected",
      documentHeaderTextPlaceholder: "e.g. store name",
      customerSecondaryField: "Customer list second line",
      customerThirdField: "Customer list third line",
      printSignatureReceipt: "Print signature receipt",
      customerDisplayField: {
        YOUR_REFERENCE: "Your reference",
        OUR_REFERENCE: "Our reference",
        ORG_NUMBER: "Organization number",
        EMAIL: "Email",
        PHONE: "Phone",
        CITY: "City",
        ADDRESS1: "Address",
        CUSTOMER_NUMBER: "Customer number",
      },
      marketPay: {
        ipAddress: "IP address",
        ipAddressRequired: "IP address required",
      },
      westpay: {
        connectionId: "Connection ID",
        tipOnScreen: "Tip on customer display",
      },
      swish: {
        additionalSettings: "Additional settings",
        swishNumber: "Swish number",
        messageToCustomer: "Message to customer",
        technicalSupplierInfo:
          "Select {{companyName}} ({{orgNumber}}) as technical supplier when setting up the Swish Commerce agreement.",
      },
      invoice: {
        paymentDuration: "Payment duration (days)",
        paymentDurationPlaceholder: "Enter number of days",
        paymentDurationRequired: "Payment duration cannot be removed once set",
        paymentDurationInvalid: "Enter a whole number of days greater than 0",
        documentHeaderText: "Text on the invoice",
      },
      order: {
        documentHeaderText: "Text on the order",
        includeOrderDate: "Include date on the order",
      },
      softpay: {
        softpayStore: "Softpay store",
      },
      viva: {
        adminOnly: "Admin only",
        multiMerchantId: "Multi merchant ID",
        viewTransactions: "View transactions",
      },
    },
    vivaTransactionsView: {
      title: "Viva transactions – {{name}}",
      breadcrumb: "Transactions",
      refresh: "Refresh",
      fromDate: "From date",
      search: "Search",
      summary: "{{count}} transactions for merchant {{merchantId}} from {{fromDate}} back to {{toDate}}",
      loading: "Loading transactions from Viva...",
      loadingMore: "Loading older transactions...",
      scrollForMore: "Scroll to load older transactions",
      limitReached: "Showing at most {{days}} days back. Pick an earlier from date to go further.",
      errorLoad: "Could not load transactions from Viva: {{message}}",
      empty: "No transactions found.",
      tableTime: "Time",
      tableTransactionId: "Transaction ID",
      tableOrderCode: "Order code",
      tableAmount: "Amount",
      tableStatus: "Status",
      tableType: "Type",
      tableMerchantReference: "Merchant reference",
      tableSourceCode: "Source code",
      tableCard: "Card",
      panelTitle: "Transaction {{id}}",
    },
    integrationsView: {
      title: "Integrations",
      loading: "Loading integrations...",
      create: "Create integration",
      errorLoad: "Error loading integrations. Please try again.",
      errorUpdate: "Error updating integration. Please try again.",
      successCreated: "Integration created successfully",
      successUpdated: "Integration updated successfully",
      successDeleted: "Integration deleted successfully",
      deleteConfirm: "Are you sure you want to delete this integration?",
      empty: "No integrations yet. Create one to get started.",
      tableType: "Type",
      tableName: "Name",
      tableCreated: "Created",
      tableUpdated: "Updated",
      tableActions: "Actions",
      delete: "Delete",
      panelCreate: "Create integration",
      panelEdit: "Edit integration: {{name}}",
      noAvailableTypes:
        "No integration types are available for this store's current package features and payment terminals.",
      type: {
        WESTPAY_CLOUD: "Westpay Cloud",
        VIVA: "Viva",
        ELAVON: "Elavon",
        PAYTRIM: "Paytrim",
        SOFTPAY: "SoftPay",
        NETS: "Nets",
        MARKETPAY: "MarketPay",
        FORTNOX: "Fortnox",
        SPIRIS: "Spiris",
        SHOPIFY: "Shopify",
        PERSONALKOLLEN: "Personalkollen",
      },
    },
    shopifyIntegrationForm: {
      summary:
        "Set up a custom Shopify app in the Partner Dashboard, save credentials here, then connect the shop.",
      guideLink: "Open Partner Dashboard setup guide",
      provisionTitle: "1. Save app credentials",
      connectTitle: "2. Connect shop",
      saveCredentials: "Save credentials",
      provisionSaved: "Credentials saved.",
      connect: "Connect Shopify",
      reconnect: "Reconnect Shopify",
      readyToConnect:
        "Credentials are saved. Click Connect Shopify to complete authorization.",
      notProvisioned:
        "Save Partner app credentials first, or contact Kassaro support.",
      oauthError: "Could not start Shopify connection. Please try again.",
      statusTitle: "Status",
      statusLine: "Provisioned: {{provisioned}} · Connected: {{connected}}",
    },
    productsView: {
      overlayLoadFailed: "Could not load this store's customizations of chain products. Reload the page to try again.",
      title: "Products",
      loading: "Loading products...",
      import: "Import",
      create: "Create product",
      panelStockSaveFailed:
        "The product was saved, but its stock could not be saved. Try again.",
      errorLoad: "Error loading products. Please try again.",
      errorSave: "Error saving product. Please try again.",
      successCreated: "Product created successfully",
      successUpdated: "Product updated successfully",
      successDeleted: "Product deleted successfully",
      deleteConfirm: "Are you sure you want to delete this product?",
      empty: "No products yet.",
      emptyHint: "Create one or import a CSV to get started.",
      tableName: "Name",
      tableArticleNumber: "Article number",
      tableUnitPrice: "Unit price",
      tableVat: "VAT %",
      tableType: "Type",
      tableUpdated: "Updated",
      tableActions: "Actions",
      delete: "Delete",
      panelCreate: "Create product",
      panelEdit: "Edit product: {{name}}",
      tableGroup: "Group",
      tableStock: "Stock",
      tableBookkeepingCostcenter: "Cost center",
      bookkeepingDefault: "Default",
      columns: "Columns",
      filters: "Filters",
      filterAll: "All",
      filterStockHas: "Has stock value",
      filterStockNone: "No stock value",
      filterBookkeepingDefault: "Default (not set)",
      searchPlaceholder: "Search products...",
      totalCount: "{{count}} products",
      saveChanges: "Save changes ({{count}})",
      showVariants: "Show variants ({{count}})",
      basePrice: "Base price {{price}}, used by variants without their own price. Click to change.",
      clearFilters: "Clear filters",
      filterStockWarning: "Stock alert",
      filterStockWarningOut: "Out of stock",
      filterStockWarningLow: "Below minimum",
      filterVariants: "Variants",
      filterVariantsHas: "With variants",
      filterVariantsNone: "Without variants",
      filterSupplier: "Supplier",
      filterNone: "None",
      filterUpdated: "Changed",
      filterUpdatedWithin: "Last {{count}} days",
      filterPrice: "Price (product or variant)",
      filterPriceFrom: "From",
      filterPriceTo: "To",
      filterChipSupplier: "Supplier: {{value}}",
      filterChipUnit: "Unit: {{value}}",
      filterChipUpdated: "Changed: {{value}}",
      filterChipPrice: "Price: {{value}}",
      filterChipPriceMin: "Price: from {{value}}",
      filterChipPriceMax: "Price: up to {{value}}",
      hideVariants: "Hide variants",
      stockAtProduct: "Product stock",
      stockLocation: "Stock location shown in the Stock column",
      stockSaveFailed: "Stock could not be saved: {{error}}",
      sync: "Sync",
      syncHint: "Sync changes · Shift-click to force a full refresh",
      filterChipSearch: 'Search: "{{value}}"',
      filterChipGroup: "Group: {{value}}",
      filterChipVat: "VAT: {{value}}",
      filterChipStockHas: "Has stock value",
      filterChipStockNone: "No stock value",
      filterChipBookkeeping: "Bookkeeping: {{value}}",
      filterChipType: "Type: {{value}}",
      statusSyncing: "Syncing…",
      statusSyncingFull: "Loading products… {{count, number}} fetched",
      statusSyncingIncremental: "Syncing updates… {{count, number}} fetched",
      loadingFull: "Loading products… {{count, number}} fetched so far",
      loadingIncremental: "Checking for updates… {{count, number}} fetched so far",
      statusError: "Sync failed",
      statusSynced: "Synced — {{count}} products loaded · {{time}}",
      bulkSelected: "{{count}} selected",
      bulkValuePlaceholder: "Value",
      bulkApply: "Apply to selected",
      bulkDelete: "Delete selected",
      bulkDeleteConfirm: "Delete {{count}} selected product(s)?",
      bulkClear: "Clear selection",
      bulkFailed: "{{count}} product(s) could not be saved.",
      chainSaveTarget: "Save changes for",
      chainSaveTargetChain: "Entire chain",
      chainSaveTargetStore: "Only this store",
      chainSaveTargetLocked: "Save or discard your changes first",
      overlayStoreValue: "Customized · Chain: {{value}}",
      overlayChainValue: "Customized in this store: {{value}}",
      overlayReset: "Use chain value",
      panelOverlaySaveFailed: "The changes could not be saved for this store: {{error}}",
    },
    productForm: {
      name: "Name",
      articleNumber: "Article number",
      productGroup: "Product group",
      none: "None",
      unit: "Unit",
      unitSearchPlaceholder: "Search units...",
      course: "Course",
      prepStation: "Prep station",
      productType: "Product type",
      typePRODUCT: "Product",
      typeSERVICE: "Service",
      typeGIFT_CARD: "Gift card",
      typeTEXT: "Text",
      unitPrice: "Unit price",
      vat: "VAT (%)",
      description: "Description",
      information: "Information",
      stockCount: "Stock count",
      barcodeCode: "Barcode",
      barcodeType: "Barcode type",
      barcodeFormatId: "Barcode format",
      openPrice: "Open price",
      serialTracking: "Serial numbers",
      requireReference: "Require reference",
      updatedAt: "Last updated",
      manufacturerArticleNumber: "Manufacturer article number",
      manufacturerBarcode: "Manufacturer barcode",
      purchasePrice: "Purchase price",
      bookkeepingAccountId: "Bookkeeping account",
      bookkeepingAccountIdPlaceholder: "Account ID (optional)",
      takeawayVat: "Takeaway VAT (%)",
      takeawayBookkeepingAccount: "Takeaway bookkeeping account",
      takeawayPrice: "Takeaway price",
      notSet: "Not set",
      deleteProduct: "Delete product",
      variantsTable: {
        price: "Price",
        codes: "Codes",
        stock: "Stock",
        policy: "Stock policy",
        allVariants: "All variants",
        varies: "Varies",
        variant: "Variant",
        thisStore: "This store",
        noPolicy: "No stock policy",
        customLevels: "Custom levels",
        min: "Minimum",
        max: "Fill up to",
        manage: "Manage variants",
        remove: "Remove variant",
        empty: "No variants",
        hint: "Empty fields inherit the product's value. Changes in the All variants row apply to every variant.",
      },
      variantOptions: {
        title: "Variant options",
        dimensions: "Dimensions",
        dimensionsHint: "Choose what the variants differ in (max {{max}})",
        productName: "Product name",
        existingVariantsValue: "{{fieldName}} for existing variants",
        existingVariantsValuePlaceholder:
          "Leave empty to keep them under other variants",
        renameValue: "Rename value",
        removeValue: "Remove value",
        newValue: "New value",
        newValuePlaceholder: "E.g. Red or XL",
        addValue: "Add",
        selectedCount: "Variants ({{count}})",
        new: "New",
        skipped: "Not created",
        existing: "Existing",
        willBeRemoved: "Removed",
        otherVariants: "Other variants",
        otherVariantsHint:
          "These variants have no value for one of the dimensions and are kept as they are.",
        generateBarcodes: "Generate barcodes for new variants",
        generateBarcodesFailed: "Could not generate barcodes. Try again.",
        apply: "Apply",
        removeTitle: "Remove variants?",
        removeMessage_one: "1 variant is removed when you save the product.",
        removeMessage_other:
          "{{count}} variants are removed when you save the product.",
        removeWithStockMessage_one:
          "1 variant is removed when you save the product. It has stock.",
        removeWithStockMessage_other:
          "{{count}} variants are removed when you save the product. Some of them have stock.",
      },
      sections: {
        noticeTitle: "Before you save",
        basicInformationTitle: "Basic information",
        basicInformationDescription:
          "Name, price, VAT, and how the product is sold.",
        restaurantTitle: "Restaurant",
        informationTitle: "Information",
        informationDescription:
          "Text shown in the product info box on the register.",
        retailTitle: "Retail",
        retailDescription:
          "Barcode, stock, article numbers, and purchase price.",
        extraTitle: "Extra fields",
        extraDescription:
          "Store-specific fields configured for this location.",
        variantsTitle: "Variants",
        modifiersTitle: "Modifiers",
        bookkeepingTitle: "Bookkeeping",
        bookkeepingDescription: "Product type and sales account.",
        takeawayTitle: "Takeaway",
        dangerTitle: "Danger zone",
        metaTitle: "Record",
        metaDescription: "Read-only timestamps for this product.",
      },
    },
    productGroupForm: {
      inheritanceIntro:
        "Values set here are inherited by products in this group. A product cannot override a field the group already defines.",
      noUnits: "No units yet.",
      createUnit: "Create a unit",
      noModifiers: "No modifiers in this chain yet.",
      productSyncEnabled: "External product sync",
      includeMainProductAsVariant: "Include main product as variant",
      variantSelectionMode: "Variant selection",
      variantSelectionModeALWAYS_PROMPT: "Always prompt for variant",
      variantSelectionModeDEFAULT_ON_PRESS:
        "Add default on tap, choose variant on long press",
      modifierGroups: "Modifier groups",
      modifiers: "Modifiers",
      alwaysAppliedModifiers: "Always applied modifiers",
      deleteGroup: "Delete group",
    },
    productGroupsView: {
      title: "Product groups",
      loading: "Loading product groups...",
      create: "Create product group",
      errorLoad: "Error loading product groups. Please try again.",
      errorSave: "Error saving product group. Please try again.",
      successCreated: "Product group created",
      successUpdated: "Product group saved",
      successDeleted: "Product group deleted",
      deleteConfirm: 'Are you sure you want to delete "{{name}}"?',
      empty: "No product groups yet.",
      emptyHint: "Create one to get started.",
      tableName: "Name",
      tableVat: "VAT",
      tableType: "Type",
      tableUnit: "Unit",
      panelCreate: "Create product group",
    },
    unitForm: {
      basicInformation: "Basic information",
      name: "Name",
      suffix: "Suffix",
      suffixPlaceholder: "e.g. kg",
      decimals: "Decimals",
      example: "Example:",
      serialScale: "Serial scale",
      enableSerialScale: "Enable serial scale",
      serialScaleUnit: "Scale unit",
      serialScaleUnitKILOGRAM: "Kilogram",
      serialScaleUnitHECTOGRAM: "Hectogram",
      serialScaleUnitGRAM: "Gram",
      deleteUnit: "Delete unit",
    },
    unitsView: {
      title: "Units",
      loading: "Loading units...",
      create: "Create unit",
      errorLoad: "Error loading units. Please try again.",
      errorSave: "Error saving unit. Please try again.",
      successCreated: "Unit created",
      successUpdated: "Unit saved",
      successDeleted: "Unit deleted",
      deleteConfirm:
        'Are you sure you want to delete "{{name}}"? Products using it will have their unit removed.',
      empty: "No units yet.",
      emptyHint: "Create one to get started.",
      tableName: "Name",
      tableSuffix: "Suffix",
      tableDecimals: "Decimals",
      panelCreate: "Create unit",
    },
    supplierForm: {
      basicInformation: "Basic information",
      name: "Name",
      orgNumber: "Organization number",
      contactPerson: "Contact person",
      contactPhone: "Contact phone",
      contactEmail: "Contact email",
      street: "Street",
      city: "City",
      postalcode: "Postal code",
      country: "Country",
      countryNone: "Not set",
      countryFINLAND: "Finland",
      countrySWEDEN: "Sweden",
      note: "Note",
      deleteSupplier: "Delete supplier",
    },
    suppliersView: {
      title: "Suppliers",
      loading: "Loading suppliers...",
      create: "Create supplier",
      errorLoad: "Error loading suppliers. Please try again.",
      errorSave: "Error saving supplier. Please try again.",
      successCreated: "Supplier created",
      successUpdated: "Supplier saved",
      successDeleted: "Supplier deleted",
      deleteConfirm: 'Are you sure you want to delete "{{name}}"?',
      empty: "No suppliers yet.",
      emptyHint: "Create one to get started.",
      tableName: "Name",
      tableContact: "Contact",
      tableCity: "City",
      panelCreate: "Create supplier",
    },
    productPageForm: {
      basicInformation: "Basic information",
      name: "Name",
      deleteProductPage: "Delete product page",
    },
    productPagesView: {
      title: "Product pages",
      loading: "Loading product pages...",
      create: "Create product page",
      errorLoad: "Error loading product pages. Please try again.",
      errorSave: "Error saving product page. Please try again.",
      successCreated: "Product page created",
      successUpdated: "Product page saved",
      successDeleted: "Product page deleted",
      deleteConfirm: 'Are you sure you want to delete "{{name}}"?',
      empty: "No product pages yet.",
      emptyHint: "Manage product pages in the POS layout editor.",
      tableName: "Name",
      panelCreate: "Create product page",
    },
    offerForm: {
      basicInformation: "Basic information",
      name: "Name",
      receiptText: "Receipt text",
      type: "Type",
      enabled: "Enabled",
      priority: "Priority",
      schedule: "Schedule",
      useSchedule: "Limit by date and time",
      startsAt: "Starts",
      endsAt: "Ends",
      useHours: "Custom hours",
      additionalSettings: "Campaign settings",
      products: "Products",
      productGroups: "Product groups",
      percentage: "Percentage",
      buyQuantity: "Buy quantity",
      payQuantity: "Pay quantity",
      quantity: "Quantity",
      price: "Price",
      unitPrice: "Unit price",
      takeawayPrice: "Takeaway price",
      prices: "Product prices",
      slots: "Combo slots",
      addSlot: "Add slot",
      removeSlot: "Remove slot",
      slot: "Slot {{number}}",
      deleteOffer: "Delete offer",
      types: {
        PERCENTAGE: "Percentage",
        BUY_X_PAY_Y: "Buy X pay Y",
        QUANTITY_PRICE: "Quantity price",
        FIXED_PRICE: "Fixed price",
        COMBO: "Combo",
      },
      weekdays: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
      },
    },
    offersView: {
      title: "Offers",
      loading: "Loading offers...",
      create: "Create offer",
      errorLoad: "Error loading offers. Please try again.",
      errorSave: "Error saving offer. Please try again.",
      successCreated: "Offer created",
      successUpdated: "Offer saved",
      successDeleted: "Offer deleted",
      deleteConfirm: 'Are you sure you want to delete "{{name}}"?',
      empty: "No offers yet.",
      emptyHint: "Create one to get started.",
      tableName: "Name",
      tableType: "Type",
      tableEnabled: "Enabled",
      tablePriority: "Priority",
      enabledYes: "Yes",
      enabledNo: "No",
      panelCreate: "Create offer",
    },
    layoutForm: {
      basicInformation: "Basic information",
      name: "Name",
      defaultProductPageId: "Default product page",
      defaultProductPageNone: "None",
      tabletColumns: "Tablet columns",
      tabletRows: "Tablet rows",
      mobileColumns: "Mobile columns",
      mobileRows: "Mobile rows",
      deleteLayout: "Delete layout",
    },
    layoutsView: {
      title: "Layouts",
      loading: "Loading layouts...",
      create: "Create layout",
      errorLoad: "Error loading layouts. Please try again.",
      errorSave: "Error saving layout. Please try again.",
      successCreated: "Layout created",
      successUpdated: "Layout saved",
      successDeleted: "Layout deleted",
      deleteConfirm: 'Are you sure you want to delete "{{name}}"?',
      empty: "No layouts yet.",
      emptyHint: "Create layouts in the POS.",
      tableName: "Name",
      tableDefaultPage: "Default page",
      noDefaultPage: "None",
      panelCreate: "Create layout",
    },
    courseForm: {
      basicInformation: "Basic information",
      name: "Name",
      sortOrder: "Sort order",
      deleteCourse: "Delete course",
    },
    coursesView: {
      title: "Courses",
      loading: "Loading courses...",
      create: "Create course",
      errorLoad: "Error loading courses. Please try again.",
      errorSave: "Error saving course. Please try again.",
      successCreated: "Course created",
      successUpdated: "Course saved",
      successDeleted: "Course deleted",
      deleteConfirm: 'Are you sure you want to delete "{{name}}"?',
      empty: "No courses yet.",
      emptyHint: "Create one to get started.",
      tableName: "Name",
      tableSortOrder: "Order",
      panelCreate: "Create course",
    },
    prepStationForm: {
      basicInformation: "Basic information",
      name: "Name",
      servingScope: "Serving scope",
      servingScopeONLY_THIS: "Only this station",
      servingScopeALL: "All stations",
      prepStationScope: "Prep station scope",
      prepStationScopeONLY_THIS: "Only this station",
      prepStationScopeALL: "All stations",
      simplifyItemsFromOtherPrepStations:
        "Simplify items from other prep stations",
      requireReference: "Require reference",
      onePrepTicketPerCourse: "One prep ticket per course",
      master: "Master station",
      isMaster: "Master station",
      mirroredPrepStations: "Mirrored prep stations",
      deletePrepStation: "Delete prep station",
    },
    prepStationsView: {
      title: "Prep stations",
      loading: "Loading prep stations...",
      create: "Create prep station",
      errorLoad: "Error loading prep stations. Please try again.",
      errorSave: "Error saving prep station. Please try again.",
      successCreated: "Prep station created",
      successUpdated: "Prep station saved",
      successDeleted: "Prep station deleted",
      deleteConfirm: 'Are you sure you want to delete "{{name}}"?',
      empty: "No prep stations yet.",
      emptyHint: "Create one to get started.",
      tableName: "Name",
      tableScope: "Scope",
      tableMaster: "Master",
      panelCreate: "Create prep station",
    },
    modifierForm: {
      basicInformation: "Basic information",
      name: "Name",
      price: "Price",
      internal: "Internal",
      maxQuantity: "Max quantity per item",
      slots: "Slots used in modifier group",
      deleteModifier: "Delete modifier",
    },
    modifiersView: {
      title: "Modifiers",
      loading: "Loading modifiers...",
      create: "Create modifier",
      errorLoad: "Error loading modifiers. Please try again.",
      errorSave: "Error saving modifier. Please try again.",
      successCreated: "Modifier created",
      successUpdated: "Modifier saved",
      successDeleted: "Modifier deleted",
      deleteConfirm: 'Are you sure you want to delete "{{name}}"?',
      empty: "No modifiers yet.",
      emptyHint: "Create one to get started.",
      tableName: "Name",
      tablePrice: "Price",
      tableVat: "VAT",
      panelCreate: "Create modifier",
    },
    modifierGroupForm: {
      basicInformation: "Basic information",
      name: "Name",
      minAmount: "Minimum amount",
      maxAmount: "Maximum amount",
      minExceedsMax: "Minimum cannot be greater than maximum",
      alwaysPrompt: "Always prompt",
      modifiers: "Modifiers",
      noModifiers: "No modifiers yet.",
      createModifier: "Create a modifier",
      deleteModifierGroup: "Delete modifier group",
    },
    modifierGroupsView: {
      title: "Modifier groups",
      loading: "Loading modifier groups...",
      create: "Create modifier group",
      errorLoad: "Error loading modifier groups. Please try again.",
      errorSave: "Error saving modifier group. Please try again.",
      successCreated: "Modifier group created",
      successUpdated: "Modifier group saved",
      successDeleted: "Modifier group deleted",
      deleteConfirm: 'Are you sure you want to delete "{{name}}"?',
      empty: "No modifier groups yet.",
      emptyHint: "Create one to get started.",
      tableName: "Name",
      tableModifiers: "Modifiers",
      panelCreate: "Create modifier group",
    },
    bookkeepingAccountForm: {
      basicInformation: "Basic information",
      name: "Name",
      accountNumber: "Account number",
      deleteAccount: "Delete account",
    },
    bookkeepingAccountsView: {
      title: "Bookkeeping accounts",
      loading: "Loading bookkeeping accounts...",
      create: "Create account",
      errorLoad: "Error loading bookkeeping accounts. Please try again.",
      errorSave: "Error saving bookkeeping account. Please try again.",
      successCreated: "Account created",
      successUpdated: "Account saved",
      successDeleted: "Account deleted",
      deleteConfirm: 'Are you sure you want to delete "{{name}}"?',
      empty: "No bookkeeping accounts yet.",
      emptyHint: "Create one to get started.",
      tableName: "Name",
      tableNumber: "Number",
      panelCreate: "Create account",
    },
    giftcardsView: {
      title: "Giftcards",
      loading: "Loading giftcards...",
      import: "Import",
      create: "Create giftcard",
      errorLoad: "Error loading giftcards. Please try again.",
      errorSave: "Error updating giftcard. Please try again.",
      successCreated: "Giftcard created successfully",
      successUpdated: "Giftcard updated successfully",
      successDeleted: "Giftcard deleted successfully",
      deleteConfirm: "Are you sure you want to delete this giftcard?",
      empty: "No giftcards yet.",
      emptyHint: "Create one to get started.",
      tableCardNumber: "Card number",
      tableInitialAmount: "Initial amount",
      tableRemainingAmount: "Remaining amount",
      tableValidUntil: "Valid until",
      tableCreated: "Created",
      tableStore: "Store",
      tableActions: "Actions",
      delete: "Delete",
      panelCreate: "Create giftcard",
      panelEdit: "Edit giftcard: {{number}}",
    },
    storeDebtsView: {
      title: "Inter-store debt",
      loading: "Loading inter-store debt...",
      errorLoad: "Could not load inter-store debt.",
      empty: "No inter-store debt yet.",
      detailTitle: "Store pair",
      notFound: "This store pair could not be found.",
      eventsLoading: "Loading events...",
      eventsError: "Could not load events.",
      eventsEmpty: "No events yet.",
      settleTitle: "Mark as paid",
      nothingToSettle: "There is no outstanding debt to settle.",
      store1: "Store 1",
      store2: "Store 2",
      debtor: "Debtor",
      amount: "Amount",
      settled: "Settled",
      owes: "{{debtor}} owes {{creditor}} {{amount}}",
      note: "Note",
      reference: "Reference",
      markAsPaid: "Mark as paid",
      events: "Events",
      eventRedemption: "Gift card redeemed",
      eventRefund: "Gift card refund",
      eventSettlement: "Payment recorded",
      eventRedemptionDetail: "{{to}} redeemed a gift card issued by {{from}}",
      eventRefundDetail: "{{from}} refunded a gift card issued by {{to}}",
      eventSettlementDetail: "{{from}} paid {{to}}",
      eventCreditNoteRedemption: "Credit note redeemed",
      eventCreditNoteRefund: "Credit note refund",
      eventCreditNoteRedemptionDetail:
        "{{to}} redeemed a credit note issued by {{from}}",
      eventCreditNoteRefundDetail:
        "{{from}} refunded a credit note issued by {{to}}",
      invalidAmount: "Enter a valid amount",
      amountExceeds: "Amount exceeds outstanding debt",
      settleFailed: "Could not record payment",
      downloadReport: "Download report",
      downloadReportFailed: "Could not download report",
      report: "Report",
      reportFrom: "From",
      reportTo: "To",
      invalidReportDates: "Select a valid date range",
    },
    creditNotesView: {
      title: "Credit notes",
      loading: "Loading credit notes...",
      create: "Create credit note",
      errorLoad: "Error loading credit notes. Please try again.",
      errorSave: "Error updating credit note. Please try again.",
      successCreated: "Credit note created successfully",
      successUpdated: "Credit note updated successfully",
      successDeleted: "Credit note deleted successfully",
      deleteConfirm: "Are you sure you want to delete this credit note?",
      empty: "No credit notes yet.",
      emptyHint: "Create one to get started.",
      tableBarcode: "Barcode",
      tableOriginalAmount: "Original amount",
      tableRemainingAmount: "Remaining amount",
      tableUseByDate: "Use by date",
      tableCreated: "Created",
      tableActions: "Actions",
      delete: "Delete",
      panelCreate: "Create credit note",
      panelEdit: "Edit credit note",
    },
    listPages: {
      storesTitle: "Stores",
      storesLoading: "Loading stores...",
      addStore: "Add store",
      emptyStores: "No stores found.",
      createStorePanel: "Create new store",
      chainsTitle: "Chains",
      chainsLoading: "Loading chains...",
      emptyChains: "No chains found.",
      resellersTitle: "Resellers",
      resellersLoading: "Loading resellers...",
      addReseller: "Add reseller",
      emptyResellers: "No resellers found.",
      createResellerPanel: "Create new reseller",
      searchStoresPlaceholder: "Search stores…",
      activeStoresOnly: "Active only",
      storesSearchNoResults: "No stores match your search.",
    },
    apiKeysView: {
      title: "API key management",
      createdTitle: "API key created!",
      saveKeyHint: "Save this key now — it will not be shown again:",
      copyClipboard: "Copy to clipboard",
      createButton: "Create API key",
      name: "Name",
      namePlaceholder: "e.g. Bundle upload key",
      descriptionOptional: "Description (optional)",
      descriptionPlaceholder: "Describe what this key is used for",
      permissions: "Permissions",
      create: "Create",
      errorLoad: "Error loading API keys. Please try again.",
      loading: "Loading API keys...",
      empty: "No API keys found. Create one to get started.",
      active: "Active",
      inactive: "Inactive",
      permissionsLabel: "Permissions: {{list}}",
      createdLabel: "Created: {{date}}",
      lastUsedLabel: "Last used: {{date}}",
      deactivate: "Deactivate",
      deactivateConfirm: "Are you sure you want to deactivate this API key?",
      delete: "Delete",
      deleteConfirm: "Are you sure you want to delete this API key? This action cannot be undone.",
    },
    bundlesView: {
      title: "Bundle management",
      columnVersions: "Versions",
      emptyVersions: "No versions found.",
      bundles: "Bundles",
      bundlesAllBrandsSubtitle: "v{{version}} · All brands",
      bundlesBrandSubtitle: "v{{version}} · {{brand}}",
      emptyBundles: "No bundles found for this version.",
      emptyBrands: "No brands found for this version.",
      toggleBrands: "Show brands",
      buildLabel: "Build",
      columnDescription: "Description",
      columnActions: "Actions",
      pillAdmin: "Admin",
      pillPublic: "Public",
      active: "Active",
      inactive: "Inactive",
      adminBadge: "Admin: {{status}}",
      publicBadge: "Public: {{status}}",
      platformSizes: "iOS: {{ios}} | Android: {{android}}",
      uploaded: "Uploaded: {{date}}",
      gitHash: "Git: {{hash}}",
      description: "Description: {{text}}",
      activateAdmins: "Activate for admins",
      activateAll: "Activate for all brands",
      activateBrandAdmins: "Activate admins for brand",
      activateBrandPublic: "Activate public for brand",
      activating: "Activating...",
      activateAdminsConfirm:
        "Activate build {{build}} for admins on all brands for v{{version}}?",
      activateAllConfirm:
        "Activate build {{build}} for all brands on v{{version}}?",
      activateBrandAdminsConfirm:
        "Activate build {{build}} for admins on {{brand}}?",
      activateBrandPublicConfirm:
        "Activate build {{build}} publicly on {{brand}}?",
      activateBrandAllConfirm:
        "Activate build {{build}} for {{brand}}?",
      activateAdminsSuccess: "Activated for admins on {{count}} brands.",
      activateAllSuccess: "Activated for {{count}} brands.",
      activateBrandAdminsSuccess: "Activated for admins on {{brand}}.",
      activateBrandPublicSuccess: "Activated publicly on {{brand}}.",
      activateBrandAllSuccess: "Activated on {{brand}}.",
      activateAdminsPartial:
        "Activated for admins on {{activated}} brands. {{skipped}} brands skipped (build not uploaded).",
      activateAllPartial:
        "Activated for {{activated}} brands. {{skipped}} brands skipped (build not uploaded).",
    },
    resellerOverview: {
      loading: "Loading reseller...",
      notFound: "Reseller not found",
      pageTitle: "Reseller overview",
      editReseller: "Edit reseller",
      logoAlt: "Reseller logo",
      resellerName: "Reseller name",
      id: "ID",
      brand: "Brand",
      contactEmail: "Contact email",
      contactEmailInfo: "Contact email info",
      contactPhone: "Contact phone",
      contactPhoneInfo: "Contact phone info",
      organizationNumber: "Organization number",
      address: "Address",
      country: "Country",
      createdAt: "Created at",
      editPanelTitle: "Edit reseller: {{name}}",
    },
    chainOverview: {
      loading: "Loading chain...",
      notFound: "Chain not found",
      pageTitle: "Chain overview",
      chainName: "Chain name",
      id: "ID",
      brand: "Brand",
      address: "Address",
      country: "Country",
      organizationNumber: "Organization number",
      reseller: "Reseller",
      noReseller: "No reseller",
      createdAt: "Created at",
      updatedAt: "Updated at",
    },
    storeCopy: {
      pageTitle: "Copy store",
      storesTitle: "Stores",
      description:
        "Copy configuration and catalog from one store to another. Existing items in the target store with the same ID are overwritten; other items in the target store are left untouched. Sales, receipts, stock levels, customers, gift cards, payment methods and integrations are never copied.",
      sourceStore: "Copy from",
      targetStore: "Copy to",
      searchPlaceholder: "Search store by name or org. number",
      searchLoading: "Loading store search...",
      searchHint: "Start typing to search stores",
      searching: "Searching...",
      alreadySelected: "Already selected",
      changeStore: "Change",
      itemsTitle: "What to copy",
      itemsDescription:
        "Store settings exclude name, address, contact details, currency, language, time zone and integrations.",
      selectAll: "Select all",
      selectNone: "Select none",
      groups: {
        settings: "Settings",
        catalog: "Catalog",
        devices: "Devices and floor plans",
      },
      items: {
        STORE_SETTINGS: "Store settings",
        UNITS: "Units",
        COURSES: "Courses",
        SUPPLIERS: "Suppliers",
        BOOKKEEPING_ACCOUNTS: "Bookkeeping accounts",
        PREP_STATIONS: "Prep stations",
        PRODUCT_GROUPS: "Product groups",
        MODIFIER_GROUPS: "Modifier groups",
        MODIFIERS: "Modifiers",
        PRODUCTS: "Products",
        OFFERS: "Offers",
        PRODUCT_PAGES: "Product pages",
        LAYOUTS: "Layouts",
        PRINTERS: "Printers",
        BARCODE_FORMATS: "Barcode formats",
        FLOOR_PLANS: "Floor plans",
        DEVICE_CONFIGS: "Device configurations",
      },
      status: {
        PROCESSING: "Copying...",
      },
      start: "Start copy",
      starting: "Starting...",
      latestJobTitle: "Latest copy to this store",
      jobProgress: "({{copied}} of {{processed}} copied)",
      jobCompleted: "Copy completed. {{copied}} copied, {{failed}} failed.",
      jobFailed: "The copy failed.",
      retry: "Retry",
      retrying: "Retrying...",
      confirmTitle: "Copy store?",
      confirmMessage:
        "The selected items will be copied from {{source}} to {{target}}. Matching items in {{target}} will be overwritten.",
      confirmStart: "Start copy",
    },
    chainSettings: {
      pageTitle: "Settings",
      loading: "Loading chain settings...",
      notFound: "Chain not found",
      chainInfoTitle: "Chain information",
      chainInfoDescription: "Update the chain's name, organization number and address.",
      name: "Chain name *",
      nameRequired: "Chain name is required",
      brand: "Brand *",
      brandRequired: "Brand is required",
      orgNumber: "Organization number *",
      orgNumberRequired: "Organization number is required",
      street: "Street *",
      streetRequired: "Street is required",
      postalCode: "Postal code *",
      postalCodeRequired: "Postal code is required",
      city: "City *",
      cityRequired: "City is required",
      infoSaved: "Chain information saved",
      chainModeTitle: "Chain mode",
      chainModeDescription:
        "Chain mode lets you manage a shared catalog for all stores in the chain. Stores can then only change the fields you allow.",
      chainModeLabel: "Activate chain mode",
      chainModeActive: "Chain mode is active. Stores follow the catalog policy below.",
      sharedCustomersTitle: "Shared customers",
      sharedCustomersDescription:
        "When this is on, every store in the chain sees the same customers. When it is off, each store only sees customers created there.",
      sharedCustomersLabel: "Share customers across stores",
      sharedCustomersSaved: "Customer sharing updated",
      sourceStore: "Copy catalog from store",
      sourceStoreNone: "Do not copy a store catalog",
      sourceStoreHint:
        "Optional. The selected store's catalog is copied to the chain and then synced to the other stores.",
      confirmTitle: "Activate chain mode?",
      confirmMessage:
        "This cannot be turned off later. The chain catalog will be created and stores will follow the chain policy.",
      confirmActivate: "Activate",
      jobProgress: "Copied {{copied}} of {{processed}} items.",
      jobFailed: "Chain mode activation failed. You can retry from where it stopped.",
      retry: "Retry activation",
      retrying: "Retrying...",
      phases: {
        COPY_UNITS: "Copying units…",
        COPY_COURSES: "Copying courses…",
        COPY_SUPPLIERS: "Copying suppliers…",
        COPY_BOOKKEEPING_ACCOUNTS: "Copying bookkeeping accounts…",
        COPY_PREP_STATIONS: "Copying prep stations…",
        COPY_PRODUCT_GROUPS: "Copying product groups…",
        COPY_MODIFIER_GROUPS: "Copying modifier groups…",
        COPY_MODIFIERS: "Copying modifiers…",
        COPY_PRODUCTS: "Copying products…",
        COPY_OFFERS: "Copying offers…",
        COPY_PRODUCT_PAGES: "Copying product pages…",
        COPY_LAYOUTS: "Copying layouts…",
        ENABLE_CHAIN_MODE: "Enabling chain mode…",
        SYNC_UNITS: "Syncing units to stores…",
        SYNC_COURSES: "Syncing courses to stores…",
        SYNC_SUPPLIERS: "Syncing suppliers to stores…",
        SYNC_BOOKKEEPING_ACCOUNTS: "Syncing bookkeeping accounts to stores…",
        SYNC_PREP_STATIONS: "Syncing prep stations to stores…",
        SYNC_PRODUCT_GROUPS: "Syncing product groups to stores…",
        SYNC_MODIFIER_GROUPS: "Syncing modifier groups to stores…",
        SYNC_MODIFIERS: "Syncing modifiers to stores…",
        SYNC_PRODUCTS: "Syncing products to stores…",
        SYNC_OFFERS: "Syncing offers to stores…",
        SYNC_PRODUCT_PAGES: "Syncing product pages to stores…",
        SYNC_LAYOUTS: "Syncing layouts to stores…",
        MOVE_GIFT_CARDS: "Moving gift cards to the chain…",
        MOVE_CREDIT_NOTES: "Moving credit notes to the chain…",
      },
      catalogPolicyTitle: "Chain policy",
      catalogPolicyDescription:
        "Control whether stores can create their own catalog items and which fields they may override.",
      catalogSettingsTitle: "Catalog settings",
      catalogSettingsDescription:
        "These settings apply to all stores in the chain and cannot be changed in store settings.",
      defaultVAT: "Default VAT",
      extraProductFieldsLabel: "Extra product fields",
      extraProductFieldName: "Name",
      extraProductFieldNamePlaceholder: "Field name",
      extraProductFieldNameRequired: "Field name is required",
      extraProductFieldShowOnReceipt: "Show on receipt",
      addExtraProductField: "Add field",
      catalogSettingsSaved: "Catalog settings saved",
      storesCanCreateLocal: "Stores can create local items",
      storesCanCreateLocalHint:
        "When off, stores cannot create their own items in this part of the catalog.",
      overridableFields: "Overridable fields",
      overridableFieldsHint: "Stores may override these fields on chain catalog items.",
      policySaved: "Chain policy saved",
      domains: {
        products: "Products",
        productGroups: "Product groups",
        modifiers: "Modifiers",
        modifierGroups: "Modifier groups",
        courses: "Courses",
        units: "Units",
        suppliers: "Suppliers",
        extraProductFields: "Extra product fields",
        bookkeepingAccounts: "Bookkeeping accounts",
        prepStations: "Prep stations",
        offers: "Offers",
        productPages: "Product pages",
        layouts: "Layouts",
      },
      fields: {
        unitPrice: "Unit price",
        takeawayPrice: "Takeaway price",
        prepStationId: "Prep station",
        bookkeepingAccountId: "Bookkeeping account",
        name: "Name",
        accountNumber: "Account number",
        printerIds: "Printers",
        printerOverrides: "Printer overrides",
        isMaster: "Master station",
        mirroredPrepStationIds: "Mirrored prep stations",
        enabled: "Enabled",
        priority: "Priority",
      },
    },
    resellerAvailableBillingItemsView: {
      title: "Available billing items",
      loading: "Loading available billing items...",
      addButton: "Add available billing item",
      bulkEnableButton: "Enable multiple",
      bulkEnableTitle: "Enable billing items for reseller",
      errorLoad: "Error loading available billing items. Please try again.",
      errorUpdate: "Error updating available billing item. Please try again.",
      successAdded: "Available billing item added successfully",
      successUpdated: "Available billing item updated successfully",
      successRemoved: "Available billing item removed successfully",
      deleteConfirm: "Are you sure you want to remove this available billing item?",
      empty: "No available billing items yet. Add one to get started.",
      tableName: "Name",
      tableType: "Type",
      tableDescription: "Description",
      tablePricing: "Pricing",
      tableActions: "Actions",
      remove: "Remove",
      panelAdd: "Add available billing item",
      panelEdit: "Edit available billing item",
    },
    notFound: {
      subtitle: "Page not found",
      message: "The page you're looking for doesn't exist or has been moved.",
      goHome: "Go home",
    },
    integrationForm: {
      typeLabel: "Integration type *",
      selectPlaceholder: "Select integration type",
    },
    packageSelectionModal: {
      saveFailed: "Failed to save: {{message}}",
      saving: "Saving...",
      saveSelection: "Add",
    },
    priceList: {
      title: "Price list",
      intro:
        "Overview of available packages, add-ons, pricing, and included features.",
      loading: "Loading price list...",
      error: "Could not load the price list. Please try again.",
      empty: "No packages or add-ons are available yet.",
      packagesSection: "Packages and pricing",
      addonsSection: "Add-ons",
      featureDescription: {
        FISCALIZATION:
          "Certified cash register with control unit, journal memory, cash drawer, and reports such as Z-reports and period reports.",
        DISCOUNT:
          "Apply discounts to individual lines or the entire purchase via the POS and as a layout button.",
        GROUPS:
          "Organize your assortment into product groups and view statistics per group.",
        PRODUCT_VARIANTS:
          "Manage products with variants such as size or color under the same product.",
        RESTAURANT_VARIANTS:
          "Manage restaurant-style variants where the base product is separate from add-ons or sizes.",
        LAYOUTS:
          "Customize buttons and navigation in the POS with custom layouts.",
        FLOOR_PLANS:
          "Floor plans for selecting tables during restaurant service.",
        CREDIT_NOTE:
          "Issue and redeem credit notes as a payment method.",
        GIFT_CARD:
          "Sell gift cards and accept gift card payments.",
        AUTOMATIC_BOOKKEEPING:
          "Automatic bookkeeping entries and integration with accounting systems.",
        RECEIPT_LOGO: "Custom logo on receipts.",
        EXTRA_PRODUCT_FIELDS:
          "Custom fields on products beyond the standard fields.",
        CUSTOMER_DISPLAY:
          "Customer-facing display showing the purchase, total, and QR code.",
        BARCODE_SCANNING:
          "Barcode scanning with EAN in the POS and as a layout button.",
        SIMPLE_STOCK: "Track stock levels per product.",
        PHONE_SUPPORT: "Phone support from Kassaro.",
        BUNDLE_MANAGEMENT:
          "Version management of product data across devices.",
        LABEL_PRINTING: "Print labels for products.",
        ORDER: "Create and manage orders as a payment method.",
        INVOICE: "Create and manage invoices.",
        SERIAL_SCALE:
          "Connect a serial scale to weigh items at checkout.",
        PURCHASE_NOTE: "Record purchase notes.",
        PRODUCT_INFO_BOX:
          "Show product information in the POS.",
        MODIFIERS:
          "Modifiers and add-ons for dishes and products.",
        TIPS: "Handle tips in the POS during payment.",
        PREP_TICKETS:
          "Print prep tickets to the kitchen when orders are fired.",
        COMBINED_PREP_TICKETS:
          "Combine multiple tabs on one prep ticket when printing.",
        SAVE_TABS:
          "Park open tabs and reopen them later.",
        SPLIT_TABS:
          "Split a tab across multiple payments or guests.",
        BILL_PREVIEW:
          "Show a proforma receipt before final payment.",
        TAKEOUT_PRICE:
          "Separate takeout prices on products.",
        ONLINE_ORDER:
          "Receive and manage online orders.",
        PURCHASE_PRICE:
          "Record and track purchase prices on products.",
        STAFF:
          "Staff management with permission groups and per-user login.",
        INTAKE: "Record and track stock deliveries.",
        PRODUCT_SYNC:
          "Sync products with external systems such as Shopify.",
        PRODUCT_IMAGES: "Upload and display images on products.",
        STOCK_TAKE: "Count physical stock and apply variances.",
        STOCK_LOCATIONS: "Keep stock per stock location and edit it per location on products.",
        STOCK_POLICIES: "Stock policies with min and max levels, seasons and a list of stock alerts.",
        INVENTORY_COSTING: "FIFO cost of goods sold from purchase prices at intake, and serial number tracking.",
        SUPPLIERS: "Manage suppliers and link them to products.",
        CUSTOMERS:
          "Save customers, attach them to a sale, and export or erase their personal data.",
        SERVICE_ORDERS:
          "Create service orders from the cart, track status, and sell them later.",
        EXTERNAL_INTEGRATIONS:
          "Send sales to external systems such as Personalkollen.",
        PUBLIC_API:
          "Let your own systems and partners read and change products through the API and receive webhooks.",
      },
    },
    userForm: {
      errorAdd: "Error adding user. Please try again.",
      createNewUser: "Create new user",
      toggleNewUser: "New user (requires password)",
      toggleExistingUser: "Existing user (email only)",
      emailRequired: "Email is required",
      emailInvalid: "Invalid email format",
      emailLabel: "Email *",
      emailPlaceholder: "Enter email address",
      passwordRequiredNew: "Password is required for new users",
      passwordMinLength: "Password must be at least 6 characters",
      passwordLabel: "Password *",
      passwordPlaceholder: "Enter password",
      accessLabel: "Access",
      accessChain: "Chain (all stores in the chain)",
      accessStore: "This store only",
      permissionGroupLabel: "Permission group",
      permissionGroupDefault: "Default permission group",
      adding: "Adding...",
      addUser: "Add user",
    },
    deviceForm: {
      platform: "Platform",
      osVersion: "OS version",
      appVersion: "App version",
      name: "Name",
      namePlaceholder: "Unnamed device",
      serialNumber: "Serial number",
      serialNumberPlaceholder: "e.g. ABC123456789",
      active: "Active",
      activeState: "Active",
      inactiveState: "Inactive",
      deviceConfig: "Device config",
      none: "None",
      lastSeen: "Last seen",
      created: "Created",
    },
    printerForm: {
      editTitle: "Edit printer",
      createTitle: "Create printer",
      name: "Name",
      ipAddress: "IP address",
      ipRequired: "Please enter an IP address",
      create: "Create",
      update: "Update",
    },
    printerList: {
      type: "Type",
      ip: "IP",
    },
    adminForms: {
      warningNotBookkept: "Warning: Changes made by admins are not bookkept.",
    },
    giftcardForm: {
      cardNumber: "Card number",
      initialAmount: "Initial amount",
      remainingAmount: "Remaining amount",
      validUntil: "Valid until",
      createdAt: "Created at",
    },
    creditNoteForm: {
      originalAmount: "Original amount",
      remainingAmount: "Remaining amount",
      useByDate: "Use by date",
      barcode: "Barcode",
      createdAt: "Created at",
    },
    resellerForm: {
      errorUpdating: "Error updating reseller. Please try again.",
      errorCreating: "Error creating reseller. Please try again.",
      nameRequired: "Reseller name is required",
      resellerName: "Reseller name *",
      resellerNamePlaceholder: "Enter reseller name",
      contactEmail: "Contact email *",
      contactEmailPlaceholder: "Enter contact email",
      contactEmailRequired: "Contact email is required",
      emailInvalid: "Invalid email format",
      contactEmailInfo: "Contact email info",
      contactEmailInfoPlaceholder: "Enter contact email info",
      contactPhone: "Contact phone",
      contactPhonePlaceholder: "Enter contact phone",
      contactPhoneInfo: "Contact phone info",
      contactPhoneInfoPlaceholder: "Enter contact phone info",
      extraInfo: "Extra info",
      extraInfoPlaceholder: "Enter extra info",
      street: "Street *",
      streetRequired: "Street is required",
      streetPlaceholder: "Enter street address",
      postalCode: "Postal code *",
      postalCodeRequired: "Postal code is required",
      postalCodePlaceholder: "Enter postal code",
      city: "City *",
      cityRequired: "City is required",
      cityPlaceholder: "Enter city",
      orgNumber: "Organization number *",
      orgNumberRequired: "Organization number is required",
      orgNumberPlaceholder: "Enter organization number",
      country: "Country *",
      brand: "Brand",
      brandPlaceholder: "Enter brand (default: Kassaro)",
      logo: "Logo",
      selectedFile: "Selected: {{name}} ({{size}} KB)",
      logoPreviewAlt: "Logo preview",
      updating: "Updating...",
      creating: "Creating...",
      updateReseller: "Update reseller",
      createReseller: "Create reseller",
    },
    resellerAvailableBillingItemForm: {
      selectTitle: "Select available billing item",
      emptySelect: "No available billing items to add.",
      pricingMonthly: "Monthly: {{formatted}}",
      pricingOneTime: "One-time: {{formatted}}",
      pricing36mo: "36 mo: {{formatted}}",
      defaultPricing: "Default pricing: {{pricing}}",
      editPricingTitle: "Edit pricing for {{name}}",
      monthlyOptional: "Monthly price (optional)",
      oneTimeOptional: "One-time price (optional)",
      prepaid36Optional: "Prepaid 36-month price (optional)",
      add: "Add",
    },
    integrationDetails: {
      nameRequired: "Name is required",
      nameLabel: "Name *",
      nameOptional: "Name",
      namePlaceholder: "Enter integration name",
      percentageRequired: "Percentage is required",
      percentageLabel: "Percentage *",
      apiKeyRequired: "API key is required",
      apiKeyLabel: "API key *",
      apiKeyPlaceholder: "Enter API key",
      merchantIdRequired: "Merchant ID is required",
      merchantIdLabel: "Merchant ID *",
      merchantIdPlaceholder: "Enter merchant ID",
      accountIdRequired: "Account ID is required",
      accountIdLabel: "Account ID *",
      accountIdPlaceholder: "Enter account ID",
      usernameRequired: "Username is required",
      usernameLabel: "Username *",
      usernamePlaceholder: "Enter username",
      passwordRequired: "Password is required",
      passwordLabel: "Password",
      passwordLabelNew: "Password *",
      passwordPlaceholder: "Enter password",
      westpayDefaultName: "Westpay + {{storeName}}",
      softpayDefaultName: "SoftPay + {{storeName}}",
      netsDefaultName: "Nets + {{storeName}}",
      personalkollenDefaultName: "Personalkollen + {{storeName}}",
      personalkollenApiKeyLabel: "Cash register key",
      personalkollenApiKeyLabelNew: "Cash register key *",
      personalkollenApiKeyHelp:
        "Found in Personalkollen under Inställningar → Arbetsplatser, column “Nyckel till kassakoppling”. The key is verified with Personalkollen when you save. Leave empty to keep the current key.",
      personalkollenExportError: {
        UNAUTHORIZED:
          "Personalkollen did not accept the key on the latest sale ({{date}}). Enter a new key and save.",
        INVALID_DATA: "Personalkollen rejected a sale ({{date}}). Contact support.",
      },
      marketpayDefaultName: "MarketPay + {{storeName}}",
      storeCodeOptional: "Store code",
      storeCodePlaceholder: "Enter store code",
      marketpayMerchantId: "Tap to Pay merchant ID",
      marketpayMerchantIdPlaceholder: "Enter merchant ID from onboarding",
      marketpayClientId: "Market Pay client ID",
      marketpayClientIdPlaceholder: "Enter client ID for SSO",
      merchantEmailLabel: "Merchant email *",
      merchantEmailPlaceholder: "merchant@example.com",
      merchantEmailRequired: "Merchant email is required",
      merchantEmailInvalid: "Enter a valid email address",
      privateCardsLabel: "Private cards (%) *",
      isvPercentagePlaceholder: "0.69",
      isvPercentageRequired: "ISV percentage is required",
      isvPercentageBelowBase:
        "The rate cannot be lower than Viva's {{base}} base fee",
      isvPercentageTier1: "{{rate}} — from 300 000 kr per month",
      isvPercentageTier2: "{{rate}} — from 100 000 kr per month",
      isvPercentageTier3: "{{rate}} — from 50 000 kr per month",
      isvPercentageTier4: "{{rate}} — below 50 000 kr per month",
      isvPercentageCustom: "Custom rate…",
      isvPercentageCustomLabel: "Custom rate for private cards (%)",
      isvAmountLabel:
        "Fixed add-on per transaction (öre) – optional, goes entirely to margin",
      isvAmountOrePlaceholder: "0",
      isvAmountRequired: "ISV amount is required",
      isvCurrencyLabel: "Currency *",
      feeSplitCardRatesHeading: "Merchant rate by card type",
      feeSplitPrivateCards: "Private cards",
      feeSplitCreditCards: "Credit cards (+{{surcharge}})",
      feeSplitCompanyCards: "Company cards (+{{surcharge}})",
      feeSplitHeading: "Fee and revenue split",
      feeSplitVivaBase: "Viva's cut",
      feeSplitIsvFee: "Our margin (ISV fee)",
      feeSplitResellerShare: "Your share (50% of the ISV fee)",
      feeSplitKassaroShare: "Kassaro's share (50% of the ISV fee)",
      feeSplitExampleHeading: "Example on a {{amount}} sale with a private card",
      feeSplitExampleTotal: "Merchant pays",
      feeSplitExampleFee: "ISV fee",
      feeSplitExampleShare: "Your share",
      vivaAdminOnlyIdsHint: "Only administrators can change merchant and account IDs.",
      vivaCreatedNextSteps:
        "The integration was created. Complete merchant onboarding using the link below when available.",
      acquirerRequestInfo:
        "A request will be sent to Kassaro with the store's company details. We will contact you to complete the acquirer agreement.",
      acquirerRequestSubmit: "Send request",
      acquirerRequestSent:
        "The request has been sent to Kassaro. We will get back to you shortly.",
      acquirerRequestDone: "Done",
      acquirerCommentLabel: "Comment",
      acquirerCommentPlaceholder: "Anything else Kassaro should know about this request",
      acquirerFeeLevelLabel: "Price list *",
      acquirerFeeLevelRequired: "Select a price list",
      acquirerFeeLevelOption: "Price list {{level}} — {{rate}} ({{model}})",
      acquirerFeeModel: {
        REV_SHARE: "rev share",
        BUY_RATE: "buy rate",
      },
      acquirerFeeRatesHeading: "Price list {{level}} rates",
      acquirerFeePrivateDebit: "Private debit cards",
      acquirerFeePrivateCredit: "Private credit cards",
      acquirerFeeBusiness: "Business cards",
      acquirerFeeModelNote: {
        REV_SHARE:
          "Price lists 1–2 are revenue share and require higher customer turnover.",
        BUY_RATE:
          "Price lists 3–6 are buy rate. Margin on price list 4 is about twice that of price list 3.",
      },
      acquirerFeeShareNote: "Acquiring income is shared 50/50.",
      onboardingStatusLabel: "Onboarding status",
      onboardingUrlLabel: "Onboarding URL",
      vivaOnboardingLinkHeading: "Merchant onboarding link",
      vivaOpenOnboardingLink: "Open onboarding link",
      vivaCopyOnboardingLink: "Copy onboarding link",
      vivaOnboardingStatusStarted: "Started",
      vivaOnboardingStatusCompleted: "Completed",
      vivaOnboardingStatusUnknown: "Unknown",
      vivaOnboardingDone: "Done",
      vivaChainRequired:
        "This store is not linked to a chain. A chain is required to create a Viva integration.",
    },
    fortnoxIntegration: {
      type: "Type",
      name: "Fortnox",
      managedOAuth:
        "This integration is managed through OAuth. To reconnect, please use the OAuth flow.",
      oauthSetup: "OAuth setup",
      connectInfo:
        "Click the button below to connect your Fortnox account. You will be redirected to Fortnox to authorize the integration.",
      connectButton: "Connect Fortnox",
    },
    spirisIntegration: {
      type: "Type",
      name: "Spiris",
      managedOAuth:
        "This integration is managed through OAuth. To reconnect, please use the OAuth flow.",
      oauthSetup: "OAuth setup",
      connectInfo:
        "Click the button below to connect your Spiris account. You will be redirected to Spiris to authorize the integration.",
      connectButton: "Connect Spiris",
    },
    packageSelection: {
      paymentTerms: "Payment terms",
      billingMonthly: "Monthly",
      billingQuarterly: "Quarterly",
      billingYearly: "Yearly",
      billingTwoYears: "2 years",
      billingThreeYears: "3 years",
      billingFourYears: "4 years",
      billingFiveYears: "5 years",
      startDate: "Start date",
      startDateHint: "When changes take effect and billing starts",
      subscriptionPackages: "Subscription packages",
      loadingPackages: "Loading packages...",
      addons: "Add-ons",
      loadingAddons: "Loading add-ons...",
      extraDevices: "Extra devices",
      activeDevices: "Devices",
      activePackage: "Active package",
      selectPackage: "Select package",
      changePackage: "Change package",
      changeAddons: "Change add-ons",
      addAddons: "Add add-ons",
      changePaymentTerminals: "Change terminals",
      addTerminals: "Add payment terminals",
      totalTerminals_one: "{{count}} terminal",
      totalTerminals_other: "{{count}} terminals",
      terminalsActiveUnused: "Active {{active}} · Unused {{unused}}",
      terminalsActiveOverage: "Active {{active}} · {{overage}} over license",
      scheduledTerminalChange: "From {{date}}: {{count}} terminals",
      terminalQuantityHistory: "Scheduled quantities",
      scheduledDeviceChange: "From {{date}}: {{count}} devices",
      changeDevices: "Change devices",
      editDetails: "Edit details",
      billingTerms: "Billing terms",
      acquirers: "Acquirer agreements",
      addAcquirer: "Add acquirer",
      editAcquirer: "Edit acquirer: {{name}}",
      noAcquirers: "No acquirer agreements yet.",
      monthlyCostSummary: "Monthly cost",
      monthlyCostTotal: "Total",
      noMonthlyCost: "No recurring monthly cost.",
      noActivePackage: "No active package.",
      noActiveAddons: "No active add-ons.",
      loading: "Loading...",
      deviceCount: "Number of devices",
      terminalCount: "Number of terminals",
      firstDeviceIncluded: "The first device is included",
      totalDevices_one: "{{count}} device",
      totalDevices_other: "{{count}} devices",
      includedInPackage_one: "{{count}} included in package",
      includedInPackage_other: "{{count}} included in package",
      includedPrice: "Included",
      extraDevicesBillable_one: "{{count}} extra device",
      extraDevicesBillable_other: "{{count}} extra devices",
      extraDevicesCost: "{{price}}/month each · {{total}}/month",
      noExtraDevicesCost: "No extra cost",
      deviceChangeInfo:
        "The package always includes {{count}} device. Extra devices are billed monthly from the date you choose.",
      deviceChangePreview: "Billing breakdown",
      deviceQuantityHistory: "Scheduled quantities",
      scheduledDeviceChanges_one: "{{count}} scheduled change",
      scheduledDeviceChanges_other: "{{count}} scheduled changes",
      additionalDevices_one: "Additional {{count}} device:",
      additionalDevices_other: "Additional {{count}} devices:",
      perMonthPerDevice: "/month per device",
      total: "Total",
      perMonth: "/month",
      discountOff: "−{{amount}}",
      paymentTerminals: "Payment terminals",
      manageTerminals: "Manage terminals",
      selectTerminalsModal: "Select payment terminals",
      done: "Done",
      price: "Price",
      add: "Add",
      perPeriod: "Per period",
      perMonthUnit: "Per month/unit",
      paidImmediately: "Paid immediately",
      changesOnSave: "Changes when saving",
      endsOn: "Ends {{date}}",
      startsOn: "Starts {{date}}",
      metaSubscription: "Subscription package",
      metaAddon: "Add-on",
      metaExtraDevices: "Extra devices",
      extraDevicesFallback: "Extra devices",
      quantityPcs: "{{count}} pcs",
      quantity: "Quantity",
      extraDeviceQuantity: "Extra devices",
      effectiveFrom: "Effective from",
      saveQuantity: "Save quantity",
      savingQuantity: "Saving...",
      noExtraDevices: "No extra devices licensed.",
      quantityFrom: "{{quantity}} from {{from}}",
      quantityFromUntil: "{{quantity}} from {{from}} until {{until}}",
      noPaymentTerminals: "No payment terminals included.",
      providerColumn: "Provider",
      billingModelColumn: "Billing",
      includedColumn: "Included",
      usedColumn: "Used",
      billingModelLicensed: "Licensed per terminal",
      billingModelMetered: "Metered ({{yearMonth}})",
      meteredUsageOverage: "{{devices}} ({{overage}} over)",
      meteredOverageWarning:
        "More Softpay devices transacted than the subscription includes. The excess is billed for the full month.",
    },
    oneTimeSecret: {
      copy: "Copy",
      copied: "Copied",
      done: "Done",
    },
    storeSettings: {
      title: "Settings",
      general: "General",
      storeInfo: "Store details",
      stock: "Stock",
      loading: "Loading settings...",
      api: "API",
      webhooksNav: "Webhooks",
      apiClients: {
        title: "API keys",
        description:
          "Let your own systems and partners read and change the store's products through the Kassaro API. Each key belongs to this store and has its own API user, so changes show in the journal as, for example, “Webshop (API)”.",
        name: "Name",
        namePlaceholder: "For example Webshop",
        access: "Access",
        scope: {
          "products:read": "Products: read",
          "products:write": "Products: write",
        },
        scopeHint: {
          "products:read": "List and read products",
          "products:write": "Create, update and delete products",
        },
        create: "Create key",
        showOnce:
          "Copy the key now. It is shown only this once and cannot be retrieved later.",
        active: "Active",
        revoked: "Revoked",
        keyEnding: "Ends in {{last4}}",
        created: "Created {{date}}",
        lastUsed: "Last used {{date}}",
        neverUsed: "Never used",
        revoke: "Revoke",
        empty: "There are no API keys yet.",
        deleteTitle: "Delete API key",
        deleteMessage:
          "Delete {{name}}? Systems that use the key stop working immediately.",
        revokeTitle: "Revoke API key",
        revokeMessage:
          "Revoke {{name}}? Systems that use the key stop working immediately, and the key cannot be turned back on.",
      },
      webhooks: {
        title: "Webhooks",
        description:
          "Kassaro sends a signed HTTPS request to your address when something you choose happens in the store.",
        url: "Address (HTTPS)",
        endpointDescription: "Description",
        eventsLabel: "Events",
        events: {
          "product.created": "Product created",
          "product.updated": "Product changed",
          "product.deleted": "Product deleted",
          "sale.completed": "Sale completed",
        },
        add: "Add webhook",
        secretShowOnce:
          "Copy the signing secret now. It is shown only this once. The receiver uses it to check that requests come from Kassaro.",
        status: {
          ACTIVE: "Active",
          PAUSED: "Paused",
          DISABLED: "Turned off",
        },
        failingSince:
          "Deliveries have failed since {{date}}. The webhook is turned off after three days without a successful delivery.",
        sendTest: "Send test",
        testSucceeded: "The test succeeded (HTTP {{status}}).",
        testFailed: "The test failed: {{error}}",
        pause: "Pause",
        activate: "Turn on",
        rotateSecret: "Change signing secret",
        deliveries: "Latest deliveries ({{count}})",
        deliveryTime: "Time",
        deliveryEvent: "Event",
        deliveryAttempt: "Attempt",
        deliveryResult: "Result",
        deliveryDuration: "Response time",
        empty: "There are no webhooks yet.",
        deleteTitle: "Delete webhook",
        deleteMessage: "Stop sending events to {{url}}?",
      },
      valuation: {
        title: "Stock valuation",
        description:
          "How stock value and the cost of goods sold are calculated in statistics, the stock report and bookkeeping.",
        method: "Valuation method",
        purchasePrice: "Purchase price",
        purchasePriceDescription:
          "Stock is valued at the product's current purchase price. Simple, but the value changes when you change the price.",
        fifo: "FIFO",
        fifoDescription:
          "The purchase price of every intake is saved, and sold goods get their cost from the oldest intakes first. Required for serial numbers.",
        active: "Active",
        valuePer: "Value per",
        pool: {
          LOCATION: "Stock location",
          STORE: "Store",
        },
        poolInline: {
          LOCATION: "stock location",
          STORE: "store",
        },
        poolHint: {
          LOCATION:
            "Each stock location has its own intakes. When stock is moved, its cost moves with it.",
          STORE:
            "The store's stock locations are valued together. Moves within the store don't change the value.",
        },
        activateWarning:
          "Opening stock is valued at the products' purchase price when you activate. Activate outside opening hours: sales made while the opening stock is read can be counted twice. The choice can't be changed afterwards.",
        cancel: "Cancel",
        activate: "Activate FIFO",
        activating: "Activating...",
        activeSince: "FIFO per {{pool}}, active since {{date}}",
        showStockValue: "Show stock value",
      },
    },
    stock: {
      title: "Stock",
      loading: "Loading stock value...",
      errorLoad: "Could not load the stock value.",
      notActiveTitle: "FIFO costing is not active",
      notActiveDescription:
        "Stock value and cost of goods by FIFO show here once you have activated FIFO under Settings.",
      openSettings: "Go to settings",
      valueTitle: "Stock value",
      activeSince: "FIFO per {{pool}}, active since {{date}}",
      totalValue: "Stock value",
      inStock: "In stock",
      units_one: "{{count}} pc",
      units_other: "{{count}} pcs",
      provisional: "Provisional cost",
      products_one: "{{count}} product",
      products_other: "{{count}} products",
      search: "Search product",
      searchPlaceholder: "Name or variant",
      location: "Stock location",
      allLocations: "All stock locations",
      product: "Product",
      quantity: "Quantity",
      averageCost: "Average cost",
      value: "Value",
      empty: "No stock with a purchase price yet.",
      provisionalNote:
        "* More has been sold than is in stock. The cost is provisional until the next intake.",
      serialIssues: "Serial numbers to check",
      serialIssuesDescription:
        "Sales where the serial number was not in stock, or where a serial-tracked item was sold without a serial number. The cost is provisional.",
      date: "Date",
      serial: "Serial number",
      issue: "Issue",
      issueReason: {
        UNKNOWN_SERIAL: "Serial number was not in stock",
        MISSING_SERIAL: "Sold without a serial number",
      },
      layers: {
        show: "Show intakes",
        showFor: "Show intakes for {{name}}",
        loading: "Loading intakes...",
        errorLoad: "Could not load the intakes.",
        receivedAt: "Received",
        from: "From",
        remaining: "Left",
        remainingOf: "{{remaining}} of {{received}}",
        withoutSerial_one: "{{count}} unit without a serial number",
        withoutSerial_other: "{{count}} units without a serial number",
        unitCost: "Purchase price",
        transferFrom: "Stock move from {{location}}",
        source: {
          OPENING: "Opening stock",
          INTAKE: "Intake",
          TRANSFER_IN: "Stock move",
          RETURN: "Return",
          SALE: "Return",
          ADJUSTMENT: "Adjustment",
          TRANSFER_OUT: "Stock move",
        },
        empty: "Nothing in stock.",
        deficit_one:
          "{{count}} unit was sold without stock and has a provisional cost of {{cost}}. The next intake is set against it first.",
        deficit_other:
          "{{count}} units were sold without stock and have a provisional cost of {{cost}} each. The next intake is set against them first.",
        next: "The oldest intake is sold first. The next item sold costs {{cost}}.",
        semiLive: "Updated within a minute or so after sales and intakes.",
      },
    },
    entitlements: {
      sectionTitle: "Active features",
      loading: "Loading features...",
      deviceLimit: "{{devices}} licensed devices",
      noFeatures: "No features granted.",
      sourceName: "Granted by",
      sourceQuantity: "Quantity",
      sourceGrants: "Includes",
      sourcePeriod: "Period",
      grantsDevices: "{{devices}} extra devices",
      ongoing: "further notice",
    },
    productImportDefaultValues: {
      defaultVat: "Default VAT",
    },
    storeForm: {
      nameRequired: "Store name is required",
      storeName: "Store name *",
      storeNamePlaceholder: "Enter store name",
      organizationNumber: "Organization number *",
      organizationNumberPlaceholder: "Enter organization number",
      organizationNumberRequired: "Organization number is required",
      displayName: "Display name *",
      displayNamePlaceholder: "Enter display name",
      displayNameRequired: "Display name is required",
      street: "Street *",
      streetPlaceholder: "Enter street address",
      streetRequired: "Street is required",
      postalCode: "Postal code *",
      postalCodePlaceholder: "Enter postal code",
      postalCodeRequired: "Postal code is required",
      city: "City *",
      cityPlaceholder: "Enter city",
      cityRequired: "City is required",
      contactPerson: "Contact person *",
      contactPersonPlaceholder: "Enter contact person",
      contactPersonRequired: "Contact person is required",
      contactEmail: "Contact email *",
      contactEmailPlaceholder: "Enter contact email",
      contactEmailRequired: "Contact email is required",
      contactPhone: "Contact phone *",
      contactPhonePlaceholder: "Enter contact phone",
      contactPhoneRequired: "Contact phone is required",
      emailInvalid: "Invalid email format",
      country: "Country *",
      currency: "Currency *",
      language: "Language *",
      creating: "Creating...",
      createStore: "Create store",
      storeActive: "Active store",
      storeActiveHint:
        "When off, the store is inactive and excluded from normal listings and flows.",
    },
    bookkeeping: {
      unknownTitle: "Unknown integration type",
      unknownMessage: "The integration type is not supported",
      connectionFailed: "Connection failed",
      connecting: "Connecting integration",
      pleaseWait: "Please wait while we complete the connection...",
      completedTitle: "Integration completed",
      connectedSuccess: "Integration connected successfully!",
      unknownError: "An unknown error occurred",
      invalidScope: "An internal error occurred. Please contact support.",
    },
    shopify: {
      connectionFailed: "Connection failed",
      connecting: "Connecting integration",
      pleaseWait: "Please wait while we complete the connection...",
      completedTitle: "Integration completed",
      connectedSuccess: "Integration connected successfully!",
      unknownError: "An unknown error occurred",
    },
    shopifyProvision: {
      shopDomain: "Shop domain",
      shopDomainPlaceholder: "your-store.myshopify.com",
      shopDomainRequired: "Shop domain is required",
      clientId: "Client ID",
      clientIdRequired: "Client ID is required",
      clientSecret: "Client secret",
      clientSecretRequired: "Client secret is required",
      guide: {
        title: "Shopify Partner Dashboard setup",
        intro:
          "Create a custom app per merchant in the Shopify Partner Dashboard before saving credentials in this form. OAuth redirects to app.kassaro.se.",
        redirectUrl: "https://app.kassaro.se/shopify/integration",
        scopes:
          "read_products, write_products, read_inventory, write_inventory, read_locations, read_publications, write_publications, read_orders",
        step1:
          "Log in to the Shopify Partner Dashboard at partners.shopify.com.",
        step2:
          "Create a new app for the merchant and select Custom distribution for their shop. Do not submit the app to the Shopify App Store.",
        step3:
          "Add this redirect URL under Allowed redirection URL(s): {{redirectUrl}}",
        step4: "Enable these Admin API access scopes: {{scopes}}.",
        step5:
          "Configure mandatory compliance webhooks (customers/data_request, customers/redact, shop/redact) to the Kassaro Pub/Sub topic, then deploy the app version for the merchant shop.",
        step6:
          "Copy the Client ID and Client secret from the app API credentials.",
        step7:
          "Enter the merchant shop domain, Client ID, and Client secret in this integration form and save.",
        step8:
          "Click Connect Shopify in this form to complete OAuth, or ask the merchant to connect from the POS app under Integrations → Shopify.",
      },
    },
    receiptsView: {
      title: "Receipts",
      loading: "Loading receipts...",
      loadingDetail: "Loading receipt...",
      errorLoad: "Error loading receipts. Please try again.",
      errorDetail: "Could not load receipt.",
      empty: "No receipts found.",
      tableNumber: "Number",
      tableType: "Type",
      tableDate: "Date",
      tableStaff: "Staff",
      tableTotal: "Total",
      searchByNumber: "Search by receipt number",
      searchPlaceholder: "Receipt number",
      searchInvalid: "Enter a valid receipt number.",
      searchNotFound: "Receipt not found.",
      search: {
        show: "Search",
        hide: "Hide search",
      },
      backToList: "Back to list",
      detailTitle: "Receipt details",
      filter: {
        type: "Type",
        staff: "Staff",
        all: "All",
        dateRange: "Date",
        date: "Date",
        startTime: "Start time",
        endTime: "End time",
        clear: "Clear filters",
        show: "Filters",
        hide: "Hide filters",
        active: "Active",
        presetToday: "Today",
        presetYesterday: "Yesterday",
      },
      detail: {
        typeReceipt: "Receipt",
        typeRefund: "Refund receipt",
        typePayout: "Payout",
        companyOrgNumber: "Org. no.",
        companyAddress: "Address",
        createdAt: "Date",
        items: "Items",
        summary: "Summary",
        payments: "Payments",
        purchaseNote: "Purchase note",
        customer: "Customer",
        fiscalization: "Fiscalization",
        total: "Total",
        vatIncluded: "VAT included",
        vatPercentage: "VAT {{percentage}}%",
        net: "Net",
        rounding: "Rounding",
        subtotal: "Subtotal",
        discount: "Discount",
        tip: "Tip",
        staff: "Staff",
        prepTicketReference: "Reference",
        originalReceipt: "Original receipt",
        original: "Original",
        refund: "Refund",
        refundReceiptsCount: "Refunds ({{count}})",
        paidVia: "Paid via {{brand}}",
        fiscalizationCashRegister: "Cash register",
        fiscalizationControlUnit: "Control unit",
        customerName: "Customer",
        customerEmail: "Email",
        customerPhone: "Phone",
        customerNote: "Note",
        paymentDetails: {
          receivedAmount: "Received",
          changeAmount: "Change",
          invoiceNumber: "Invoice no.",
          orderNumber: "Order no.",
          reference: "Reference",
          dueDate: "Due date",
          customer: "Customer",
          ocr: "OCR",
          orgNumber: "Org. no.",
        },
        purchaseNoteName: "Name",
        purchaseNotePhone: "Phone",
        purchaseNoteSsn: "Personal ID",
        purchaseNoteProductInfo: "Product info",
        purchaseNoteAddress: "Address",
        purchaseNoteIdType: "ID type",
      },
    },
    publicReceipt: {
      loading: "Loading receipt...",
      notFoundTitle: "Receipt not found",
      notFound: "This receipt link is invalid.",
      errorGeneric: "Something went wrong. Please try again.",
      saveTitle: "Save your receipt",
      saveDescription: "Download a PDF or send the receipt to your email.",
      downloadPdf: "Download PDF",
      downloading: "Downloading...",
      emailPlaceholder: "Email address",
      emailInvalid: "Invalid email address",
      emailSend: "Send by email",
      sending: "Sending...",
      emailSuccess: "Receipt sent to your email.",
    },
    sidebar: {
      store: "Store",
      overview: "Overview",
      statistics: "Statistics",
      receipts: "Receipts",
      devices: "Devices",
      users: "Users",
      products: "Products",
      productImport: "Product Import",
      giftcards: "Giftcards",
      creditNotes: "Credit Notes",
      admin: "Admin",
      invoicing: "Invoicing",
      integrations: "Integrations",
      paymentMethods: "Payment methods",
      aiAssistant: "AI assistant",
      chatSessions: "Chat sessions",
      catalog: "Catalog",
      stock: "Stock",
      settings: "Settings",
    },
    storeChatSessions: {
      title: "Chat sessions",
      subtitle: "Browse conversations and start a new session with a first message.",
      newSessionPlaceholder: "Type the first message to start a new session…",
      newChat: "New chat",
      starters: {
        setupTitle: "Set up the store",
        setupHint:
          "Pick a concept and the assistant asks a few questions and prepares a proposal you review before anything is saved.",
        tasksTitle: "Or start with one of these",
        setup: {
          basic_retail: {
            label: "Retail store",
            message: "I want to set up the store as a regular retail store.",
          },
          cafe: {
            label: "Café",
            message: "I want to set up the store as a café.",
          },
          restaurant: {
            label: "Restaurant",
            message: "I want to set up the store as a restaurant.",
          },
          bar: {
            label: "Bar",
            message: "I want to set up the store as a bar.",
          },
          takeaway: {
            label: "Takeaway",
            message: "I want to set up the store as a takeaway food place.",
          },
          service: {
            label: "Salon / services",
            message: "I want to set up the store as a salon that sells services.",
          },
        },
        tasks: {
          addProducts: {
            label: "Add products",
            message: "I want to add new products.",
          },
          menuPhoto: {
            label: "Add my menu from a photo",
            message: "I want to add my menu. I am attaching a photo of it.",
          },
          layout: {
            label: "Change the till layout",
            message: "I want to change which buttons and products are shown on the till.",
          },
          receipt: {
            label: "Change the receipt",
            message: "I want to change what the receipt says.",
          },
        },
      },
      startSession: "Start session",
      creating: "Starting…",
      emptyList: "No sessions yet.",
      selectSession: "Select a session on the left to view the conversation.",
      noMessages: "No messages in this session yet.",
      sessionIdPrefix: "Session",
      loadFailed: "Could not load chat sessions.",
      messagesLoadFailed: "Could not load messages for this session.",
      createFailed: "Could not start session.",
      thinking: "Assistant is thinking…",
      replyPlaceholder: "Write a message…",
      dropFilesHint: "Drop files here",
      send: "Send",
      sending: "Sending…",
      sendFailed: "Could not send message.",
      agentProgress: {
        thinking: "Thinking…",
        get_store: "Looking up store settings…",
        get_store_settings: "Looking up store settings…",
        get_products: "Looking up products…",
        get_product_groups: "Looking up product groups…",
        get_modifiers: "Looking up modifiers…",
        get_modifier_groups: "Looking up modifier groups…",
        get_layouts: "Looking up layouts…",
        get_product_pages: "Looking up product pages…",
        get_device_configs: "Looking up device configs…",
        get_devices: "Looking up devices…",
        get_prep_stations: "Looking up prep stations…",
        get_bookkeeping_accounts: "Looking up bookkeeping accounts…",
        get_payment_methods: "Looking up payment methods…",
        get_units: "Looking up units…",
        get_courses: "Looking up courses…",
        get_printers: "Looking up printers…",
        get_floor_plans: "Looking up floor plans…",
        get_floor_plan_schema: "Reading floor plan schema…",
        get_lookup_schema: "Reading lookup documentation…",
        get_change_request_schema: "Reading change request schema…",
        get_change_request: "Checking change request…",
        upsert_change_request: "Updating change request…",
        kassaro_docs: "Searching documentation…",
        get_store_config: "Fetching store configuration…",
        catalog_specialist: "Preparing catalog changes…",
        settings_specialist: "Preparing settings changes…",
        layout_specialist: "Preparing till layout changes…",
        get_layout_schema: "Reading layout schema…",
        get_offers: "Fetching offers…",
        get_suppliers: "Fetching suppliers…",
        get_online_order_settings: "Fetching online ordering settings…",
        list_store_templates: "Fetching store concepts…",
        get_store_template: "Reading concept questions…",
        build_store_setup: "Building the store setup…",
        transfer_to_StoreSetup: "Starting store setup…",
        transfer_to_KassaroAssistant: "Returning to the assistant…",
        fallback: "Working on your request…",
      },
      changeRequest: {
        title: "Change request",
        before: "Before",
        after: "After",
        empty: "No change request yet. The assistant can add one when suggesting changes.",
        approve: "Approve and apply",
        approving: "Applying…",
        approveFailed: "Could not approve the change request.",
        retry: "Try again",
        applied: "Applied",
        partiallyAppliedHint: "Applying stopped. Changes already applied are saved; ask the assistant to fix the rest and try again.",
        missingPermissions: "You do not have permission to approve changes in: {{permissions}}",
        permissions: {
          PRODUCT_MANAGEMENT: "Product management",
          STORE_SETTINGS: "Store settings",
          RESTAURANT_SETUP: "Restaurant setup",
          MANAGE_FLOOR_PLANS: "Floor plans",
          MANAGE_LAYOUTS: "Layouts",
          MANAGE_PRODUCT_PAGES: "Product pages",
          MANAGE_ONLINE_ORDERS: "Online ordering",
          DEVICE_CONFIGURATION: "Device configuration",
          PAYMENT_METHOD_MANAGEMENT: "Payment methods",
          PRINTERS_MANAGEMENT: "Printers",
          MANAGE_OFFERS: "Offers",
        },
        more: "and {{count}} more",
        layoutItemTypes: {
          PRODUCT: "Product",
          PRODUCT_PAGE: "Product page",
          MENU_LINK: "Menu link",
          WEBSITE: "Website",
          DISCOUNT: "Discount",
          GIFT_CARD: "Gift card",
          PRODUCT_SEARCH: "Product search",
          BARCODE_MODAL: "Barcode",
          SCALE_VALUE: "Scale",
          SHOW_CLOCK: "Clock",
          SHOW_DATE: "Date",
          OPEN_CASHBOX: "Open cash drawer",
          ACTIVE_TAB: "Tabs",
          SPLIT_TAB: "Split tab",
          PRINT_PROFORMA: "Print pro forma",
          FORWARD_PREP_STATION: "Send to kitchen",
          WAIT_PREP_STATION: "Hold for kitchen",
          COMBINED_PREP_TICKET: "Combined ticket",
          TOGGLE_TAKEAWAY: "Takeaway",
          TEXT_ITEM: "Text",
          SELECT_STORE: "Select store",
          SET_REFERENCE: "Reference",
          ORDER_PAGE: "Orders",
          STAFF_SELECT: "Select staff",
          SHOW_ALL: "Show all",
          PAYMENT_METHOD: "Payment method",
          SELECT_CUSTOMER: "Select customer",
          SERVICE_ORDER: "Service order",
          SERVICE_ORDER_DEPOSIT: "Deposit",
        },
        statuses: {
          DRAFT: "Draft",
          PARTIALLY_APPLIED: "Partially applied",
          APPROVED: "Approved",
          DISCARDED: "Discarded",
        },
        showDetails: "Show details",
        hideDetails: "Hide details",
        variantCount: "{{count}} variants",
        values: {
          ALWAYS: "Always",
          OFF: "Off",
          ON_LONG_PRESS: "On long press",
          PRODUCT: "Product",
          SERVICE: "Service",
          CASH: "Cash",
          SWISH_COMPANY: "Swish",
          OTHER: "Other",
          GIFT_CARD: "Gift card",
          CREDIT_NOTE: "Credit note",
          IP_PRINTER: "Network printer",
          BUILT_IN_SUNMI: "Built-in printer",
          NAME: "Name",
          PIN: "PIN code",
          BUY_X_PAY_Y: "Buy X pay for Y",
          QUANTITY_PRICE: "Quantity price",
          FIXED_PRICE: "Fixed price",
          PERCENTAGE: "Percentage off",
          COMBO: "Combo",
          RECT: "Rectangular",
          ROUND: "Round",
        },
        operations: {
          product_create: "New product",
          product_update: "Update product",
          product_delete: "Delete product",
          group_create: "New product group",
          group_update: "Update product group",
          group_delete: "Delete product group",
          modifier_create: "New modifier",
          modifier_update: "Update modifier",
          modifier_delete: "Delete modifier",
          modifier_group_create: "New modifier group",
          modifier_group_update: "Update modifier group",
          modifier_group_delete: "Delete modifier group",
          unit_create: "New unit",
          unit_update: "Update unit",
          unit_delete: "Delete unit",
          prep_station_create: "New prep station",
          prep_station_update: "Update prep station",
          prep_station_delete: "Delete prep station",
          bookkeeping_account_create: "New bookkeeping account",
          bookkeeping_account_update: "Update bookkeeping account",
          bookkeeping_account_delete: "Delete bookkeeping account",
          floor_plan_create: "New floor plan",
          floor_plan_update: "Update floor plan",
          floor_plan_delete: "Delete floor plan",
          layout_create: "New layout",
          layout_update: "Update layout",
          layout_delete: "Delete layout",
          product_page_create: "New product page",
          product_page_update: "Update product page",
          product_page_add_items: "Add to product page",
          product_page_delete: "Delete product page",
          store_settings_update: "Update store settings",
          online_order_settings_update: "Update online ordering",
          device_config_create: "New device configuration",
          device_config_update: "Update device configuration",
          device_config_delete: "Delete device configuration",
          payment_method_create: "New payment method",
          payment_method_update: "Update payment method",
          payment_method_delete: "Delete payment method",
          printer_create: "New printer",
          printer_update: "Update printer",
          printer_delete: "Delete printer",
          course_create: "New course",
          course_update: "Update course",
          course_delete: "Delete course",
          offer_create: "New offer",
          offer_update: "Update offer",
          offer_delete: "Delete offer",
          supplier_create: "New supplier",
          supplier_update: "Update supplier",
          supplier_delete: "Delete supplier",
        },
        domains: {
          product: "Products",
          group: "Product groups",
          modifier: "Modifiers",
          modifier_group: "Modifier groups",
          unit: "Units",
          prep_station: "Prep stations",
          bookkeeping_account: "Bookkeeping accounts",
          floor_plan: "Floor plans",
          layout: "Layouts",
          product_page: "Product pages",
          store_settings: "Store settings",
          online_order_settings: "Online ordering",
          device_config: "Device configurations",
          payment_method: "Payment methods",
          printer: "Printers",
          course: "Courses",
          offer: "Offers",
          supplier: "Suppliers",
        },
        errors: {
          change_request_apply_unresolved_operation_ref:
            "The change request references an operation that is missing or has not been applied yet. Ask the assistant to update the draft.",
          change_request_apply_cyclic_operation_refs:
            "The change request contains circular references between operations and cannot be applied.",
          change_request_apply_invalid_operations:
            "The change request contains invalid operations and cannot be applied.",
          change_request_apply_create_payload_invalid:
            "An operation in the change request has invalid values and cannot be applied.",
          change_request_apply_update_patch_invalid:
            "An update operation in the change request has invalid values.",
          change_request_apply_product_not_found:
            "The product referenced by the change request was not found.",
          change_request_apply_group_not_found:
            "The product group referenced by the change request was not found.",
          change_request_apply_modifier_not_found:
            "The modifier referenced by the change request was not found.",
          change_request_apply_modifier_group_not_found:
            "The modifier group referenced by the change request was not found.",
          change_request_apply_unit_not_found:
            "The unit referenced by the change request was not found.",
          change_request_apply_prep_station_not_found:
            "The prep station referenced by the change request was not found.",
          change_request_apply_bookkeeping_account_not_found:
            "The bookkeeping account referenced by the change request was not found.",
          change_request_apply_floor_plan_not_found:
            "The floor plan referenced by the change request was not found.",
          change_request_apply_layout_not_found:
            "The layout referenced by the change request was not found.",
          change_request_apply_product_page_not_found:
            "The product page referenced by the change request was not found.",
          change_request_apply_device_config_not_found:
            "The device configuration referenced by the change request was not found.",
          change_request_apply_payment_method_not_found:
            "The payment method referenced by the change request was not found.",
          change_request_apply_printer_not_found:
            "The printer referenced by the change request was not found.",
          change_request_apply_course_not_found:
            "The course referenced by the change request was not found.",
          change_request_apply_offer_not_found:
            "The offer referenced by the change request was not found.",
          change_request_apply_supplier_not_found:
            "The supplier referenced by the change request was not found.",
        },
        yes: "Yes",
        no: "No",
        fields: {
          id: "ID",
          name: "Name",
          type: "Type",
          unitPrice: "Unit price",
          VAT: "VAT",
          openPrice: "Open price",
          groupId: "Group",
          unitId: "Unit",
          bookkeepingAccountId: "Bookkeeping account",
          bookkeepingCostcenter: "Cost center",
          information: "Information",
          image: "Image",
          purchasePrice: "Purchase price",
          barcode: "Barcode",
          stockCount: "Stock",
          articleNumber: "Article number",
          manufacturerArticleNumber: "Mfr. article number",
          manufacturerBarcode: "Mfr. barcode",
          extraFields: "Extra fields",
          variants: "Variants",
          prepStationId: "Prep station",
          courseId: "Course",
          requireReference: "Require reference",
          modifiers: "Modifiers",
          modifierGroups: "Modifier groups",
          alwaysAppliedModifiers: "Always applied modifiers",
          takeawayVAT: "Takeaway VAT",
          takeawayBookkeepingAccountId: "Takeaway bookkeeping account",
          takeawayPrice: "Takeaway price",
          description: "Description",
          tags: "Tags",
          price: "Price",
          productGroupId: "Product group",
          internal: "Internal",
          minAmount: "Min amount",
          maxAmount: "Max amount",
          alwaysPrompt: "Always prompt",
          suffix: "Suffix",
          decimals: "Decimals",
          enableSerialScale: "Serial scale",
          serialScaleUnit: "Scale unit",
          printerIds: "Printers",
          servingScope: "Serving scope",
          prepStationScope: "Prep station scope",
          simplifyItemsFromOtherPrepStations: "Simplify other prep stations",
          accountNumber: "Account number",
          mapWidth: "Map width",
          mapHeight: "Map height",
          mapEnabled: "Map enabled",
          tables: "Tables",
          decorations: "Decorations",
          topButtons: "Top buttons",
          bottomButtons: "Bottom buttons",
          leftButtons: "Left buttons",
          rightButtons: "Right buttons",
          checkoutButtons: "Checkout buttons",
          defaultProductPageId: "Start page",
          items: "Buttons",
          layoutId: "Layout",
          receiptText: "Receipt text",
          tipPromptBehavior: "Tips",
          paymentMethodsOrder: "Payment method order",
          swishNumber: "Swish number",
          sortOrder: "Order",
        },
      },
    },
    storeAi: {
      badge: "AI assistant",
      subtitle: "Ask questions about this store’s products. Creating or changing products requires your approval.",
      approvalHint: "When the assistant proposes a change, review the card below before it is saved.",
      pendingBanner: "You have a pending change to review.",
      scrollToProposal: "Go to proposal",
      thinking: "Assistant is thinking…",
      proposedNewProduct: "Proposed new product",
      proposedProductChange: "Proposed product change",
      kindCreate: "Create",
      kindUpdate: "Update",
      before: "Before",
      after: "After",
      approve: "Approve",
      rejecting: "Rejecting…",
      approving: "Approving…",
      reject: "Reject",
      placeholder: "Message the assistant…",
      send: "Send",
      sending: "Sending…",
      unavailable: "Assistant is not available.",
      sendFailed: "Could not send message.",
      changeApplied: "Change applied: {{name}}.",
      productLinkIntro: "You can open products from here:",
      openProducts: "Products",
      approveFailed: "Could not approve the change.",
      rejectFailed: "Could not reject the change.",
      vat: "VAT",
      batchCreateSummary: "{{count}} new products in this proposal.",
      batchUpdateSummary: "{{count}} products in this proposal.",
      changesAppliedBatch: "Changes applied: {{names}}.",
      productsLinkIntro: "Updates applied to {{count}} products.",
      addImages: "Add images",
      imageAlt: "Attached image",
      removeImage: "Remove",
      imageTooMany: "You can attach at most 8 images per message.",
      imageTooLarge: "Each image must be at most 8 MB.",
      imagesTotalTooLarge: "Images in this message must total at most 25 MB.",
      imageTypeInvalid: "Only JPEG, PNG, WebP, and GIF images are allowed.",
    },
  },
};
